<template>
  <div id="page-send-mail" class="p-6">
    <!-- button mail-->
    <div class="pt-6 mb-4">
      <div class="flex flex-wrap items-end justify-end">
        <!----Send mode------>
        <vs-switch v-model="bulkMode" v-if="(isShachihataDesk ? !isShachihataDesk : !isRead)">
          <span slot="on">一括送信</span>
          <span slot="off">個別送信</span>
        </vs-switch>
        <vs-button v-if="isRead" color="primary" class="px-6" :disabled="readOnly" @click="onSaveDraftForwardDuplicate">転送</vs-button>
        <vs-button v-if="isRead" color="primary" class="mx-2" :disabled="readOnly" @click="onSaveDraftDuplicate">返信メール作成</vs-button>
        <vs-button v-if="isSetPreviousMail"  color="primary" class="mx-2" @click="setPreMailDraft">クリア</vs-button>
        <vs-button :disabled="(bulkMode && !csv_data) || (!bulkMode && listMailTo.length == 0 && !this.mailTo && to == null) || !this.mailFrom || isRead || readOnly" @click="beforeSendMail" color="success" icon="send">送信</vs-button>
          <vs-button v-if='(isShachihataDesk ? !isShachihataDesk : !isEmbedded)' color="#d9d9d9" icon="cancel" @click="buttonBack">戻る</vs-button>
      </div>
    </div>

    <!-- dialog confirm to close current tab when sent mail success -->
    <PopupConfirm
      :activeModelCloseTab="activeModelCloseTab"
      modelTitle="メールの送信に成功しました。"
      v-on:closeCurrentTab="closeCurrentTab"
      eventEmitYes="closeCurrentTab"
      buttonTitleYes=" 閉じる"
    >
    </PopupConfirm>

    <!-- dialog contact list -->
    <Contacts
      :activeModelContacts="activeModelContacts"
      :typeModalContact = "typeModalContact"
    >
    </Contacts>

    <!-- dialog confirm send: no subject, content -->
    <vs-popup id="dialogSend" :title="titleDialog" :active.sync="activeSend" button-close-hidden>
        <div>
          <span>
            {{confirmQuestion}}
          </span>
        </div>
        <div class="flex justify-end mt-4">
            <vs-button @click="confirm" icon="check" color="success" class="mx-2">はい</vs-button>
            <vs-button @click="activeSend = false" icon="cancel" color="lightgrey">キャンセル</vs-button>
        </div>
      </vs-popup>

    <!-- email from.to -->
      <div class="mail-from-to">
        <vs-row class="flex-wrap items-center justify-start row-email">
          <vs-col vs-w="1">
              <span class="pl-2">返信No</span>
          </vs-col>
          <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
            <input v-model="countReplyMail" disabled class="w-full pl-2 background_color__white"/>
          </vs-col>
        </vs-row>
        <vs-row class="flex-wrap items-center justify-start row-email" v-if="isRead && sentDateTime">
          <vs-col vs-w="1">
              <span class="pl-2">送信日時</span>
          </vs-col>
          <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
            <input v-model="sentDateTime" disabled class="w-full pl-2 background_color__white"/>
          </vs-col>
        </vs-row>
        <vs-row class="flex-wrap items-center justify-star row-email">
          <vs-col vs-w="1">
              <span class="block leading-none pl-2">方法</span>
          </vs-col>
          <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
            <v-select class="w-full" v-if="isReport"
                    id="inquiryType"
                    v-model="inquiryType"
                    :options="listInquiryTypeSelect"
                    :searchable="false">
              <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
            </v-select>
              <div class="w-full" v-else>
                  <input v-if="inquiryType && inquiryType.label" v-model="inquiryType.label" disabled class="w-full pl-2 background_color__white"/>
                  <input v-else disabled class="w-full pl-2 background_color__white"/>
              </div>
          </vs-col>
        </vs-row>
        <vs-row class="flex-wrap items-center justify-star row-email">
          <vs-col vs-w="1">
            <span class="block leading-none pl-2">種別</span>
          </vs-col>
          <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
            <v-select class="w-full" v-if="isReport"
                      id="type"
                      v-model="type"
                      :options="listTypeSelect"
                      :searchable="false">
              <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
            </v-select>
            <div class="w-full" v-else>
                <input v-if="type && type.label" v-model="type.label" disabled class="w-full pl-2 background_color__white"/>
                <input v-else disabled class="w-full pl-2 background_color__white"/>

            </div>
          </vs-col>
        </vs-row>
        <vs-row class="flex-wrap items-center justify-star row-email">
          <vs-col vs-w="1">
            <span class="block leading-none pl-2">担当者</span>
          </vs-col>
          <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
            <v-select class="w-full" v-if="isReport"
                      id="mst_user"
                      v-model="mst_user"
                      :options="listMstUserSelect"
                      :searchable="false">
              <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
            </v-select>
             <div class="w-full" v-else>
                 <input v-if="mst_user && mst_user.label" v-model="mst_user.label" disabled class="w-full pl-2 background_color__white"/>
                 <input v-else disabled class="w-full pl-2 background_color__white"/>
             </div>
          </vs-col>
        </vs-row>
        <vs-row class="flex-wrap items-center justify-star row-email">
          <vs-col vs-w="1">
              <span class="pl-2">From</span>
          </vs-col>
          <vs-col vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail">
            <input v-if="!isReport" v-model="mailFrom" class="w-full pl-2" readonly/>
            <v-select class="w-full"
                    v-else
                    id="from"
                    v-model="mailFrom"
                    :options="listMailFrom"
                    :searchable="false">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
          </vs-col>
        </vs-row>
        <vs-row class="flex-wrap items-center justify-start row-email" v-if="!bulkMode">
          <vs-col vs-w="1">
              <span class="pl-2">To</span>
          </vs-col>
          <vs-col id="tags-to" vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail" style="position: relative;">
              <input v-if="to != null" v-model="to" id="too" class="w-full pl-2"/>
              <vs-chips v-else v-model="listMailTo" :class="{'pointer-events-none': isRead}" class="w-full vschipsContacts" ref="vsChipTo" id="vschipsTo">
              <vs-chip v-for="(to, index) in listMailTo"
                       :key=to+index :id="'tag-to-'+ index"
                       :closable="!isRead"
                       :color="validateEmail(to)?'dark':'danger'"
                       transparent
                       @click="listMailTo.splice(index,1), sendlistMailTo.splice(index,1)"
                       >
                {{to | convertEmail}}
              </vs-chip>
            </vs-chips>
            <ul class="w-full rounded-b-lg" id="contacts_dropdown" style="z-index: 100000; position: absolute !important; background-color: #FFFFFF; top: 38px; border-bottom: 3px; box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; padding-bottom: 5px;">
              <li v-for="(to, index) in listContactComputed" @click="contactSelected(to.mail_address,'TO')" class="cursor-pointer contact-li">{{ to.mail_address }}</li>
            </ul>
            <feather-icon v-show="showIconContacts" icon="BookOpenIcon" class="cursor-pointer z-100" @click="showListContact('TO')" style="position: absolute !important; right: 17px;"/>
          </vs-col>
        </vs-row>
         <vs-row>
          <vs-col vs-offset="1"  vs-w="11">
              <span class="error-form">{{errors.first('mailCC') | convertError}}</span>
          </vs-col>
        </vs-row>
        <vs-row class="flex-wrap items-center justify-start row-email">
          <vs-col vs-w="1">
              <span class="pl-2">CC</span>
          </vs-col>
          <vs-col id="tags-cc" vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail" style="position: relative;">
            <input v-if="cc != null" v-model="cc" id="ccc" class="w-full pl-2"/>
            <vs-chips v-else :class="{'pointer-events-none': isRead}" v-model="listMailCC" class="w-full vschipsContacts" ref="vsChipCc" id="vschipsCc">
              <vs-chip v-for="(cc, index) in listMailCC" :key=cc+index :id="'tag-cc-'+ index" :closable="!isRead" :color="validateEmail(cc)?'dark':'danger'" transparent @click="listMailCC.splice(index,1), sendlistMailCC.splice(index,1)">
                {{cc | convertEmail}}
              </vs-chip>
            </vs-chips>
            <!-- <input type="text" v-model="mailCC" name="mailCC"  @keyup.enter="handleInputEmailCC()"/> -->
            <ul class="w-full rounded-b-lg" id="contacts_dropdown_cc" style="z-index: 100000; position: absolute !important; background-color: #FFFFFF; top: 38px; border-bottom: 3px; box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; padding-bottom: 5px;">
              <li v-for="(to, index) in listContactComputed" @click="contactSelected(to.mail_address,'CC')" class="cursor-pointer contact-li">{{ to.mail_address }}</li>
            </ul>
            <feather-icon v-show="showIconContacts" icon="BookOpenIcon" class="cursor-pointer z-100" @click="showListContact('CC')" style="position: absolute !important; right: 17px;"/>
          </vs-col>
        </vs-row>
         <vs-row>
          <vs-col vs-offset="1"  vs-w="11">
              <span class="error-form">{{errors.first('mailBCC') | convertError}}</span>
          </vs-col>
        </vs-row>
        <vs-row class="flex-wrap items-center justify-start row-email">
          <vs-col vs-w="1">
              <span class="pl-2">BCC</span>
          </vs-col>
          <vs-col id="tags-bcc" vs-w="11" class="flex flex-wrap items-center justify-start input-tag-mail" style="position: relative;">
            <input v-if="bcc != null" v-model="bcc" id="bccc" class="w-full pl-2"/>
            <vs-chips v-else :class="{'pointer-events-none': isRead}" v-model="listMailBCC" class="w-full vschipsContacts" ref="vsChipBcc" id="vschipsBcc">
              <vs-chip v-for="(bcc, index) in listMailBCC" :key=bcc+index :id="'tag-bcc-'+ index" :closable="!isRead" :color="validateEmail(bcc)?'dark':'danger'" transparent @click="listMailBCC.splice(index,1)">
                {{bcc | convertEmail}}
              </vs-chip>
            </vs-chips>
            <!-- <input type="text" v-model="mailBCC" name="mailBCC"  @keyup.enter="handleInputEmailBCC()"/> -->
            <ul class="w-full rounded-b-lg" id="contacts_dropdown_bcc" style="z-index: 100000; position: absolute !important; background-color: #FFFFFF; top: 38px; border-bottom: 3px; box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; padding-bottom: 5px;">
              <li v-for="(to, index) in listContactComputed" @click="contactSelected(to.mail_address,'BCC')" class="cursor-pointer contact-li">{{ to.mail_address }}</li>
            </ul>
            <feather-icon v-show="showIconContacts" icon="BookOpenIcon" class="cursor-pointer z-100" @click="showListContact('BCC')" style="position: absolute !important; right: 17px;"/>
          </vs-col>
        </vs-row>
      </div>

      <!-- CSV file -->
      <div v-if="bulkMode" class="mt-10 card-file-input">
        <vs-row class="flex-wrap justify-start items-center row-card-file">
          <vs-col vs-w="1.75" class="card-title">
            <span class="pl-2">CSVファイルの内容</span>
          </vs-col>
          <vs-col vs-w="2.5" class="flex flex-wrap items-center justify-start input-tag-file">
            <div class="pl-2" >
              <input type="file" ref="csv_file" accept=".csv" @click="$refs.csv_file.value=''" v-on:change="handleCSVFile" style="display: none"/>
              <vs-button :disabled="isRead" color='darkgray' @click="$refs.csv_file.click()">CSVファイル選択</vs-button>
            </div>
          </vs-col>
          <vs-col vs-w="6.75">
            <div v-if="csv_file" style="display: inline-block" >
              <vs-chip class="mt-1 mr-1" color="dark" transparent closable @click="removeCSVFile">{{this.csv_file}}</vs-chip>
            </div>
          </vs-col>
        </vs-row>
        <div class="card-subject csv-content">
          <div class="w-full div-subject" v-if="!csv_data">CSVファイルがありません。</div>
          <div class="w-full" v-else>
            <vs-table stripe noDataText='' :data="csv_raw">
              <template>
                <vs-th v-for="(header,index) in csv_header" :key="header+index"> {{header}} </vs-th>
              </template>
              <template>
                <vs-tr v-for="(row,row_idx) in csv_raw" :key="row+row_idx">
                  <vs-td v-for="(value, value_idx) in row" :key="value+value_idx">
                    {{value}}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
      
      <!-- file -->
      <div class="mt-10 card-file-input">
        <vs-row class="flex-wrap justify-start items-center row-card-file">
          <vs-col vs-w="1.5" class="card-title">
            <span class="pl-2">添付ファイル</span>
          </vs-col>
          <vs-col vs-w="1.75" class="flex flex-wrap items-center justify-start input-tag-file">
            <div class="pl-2" >
              <input type="file" multiple ref="files" v-on:change="handleFiles" style="display: none"/>
              <vs-button :disabled="isRead" color='darkgray' @click="$refs.files.click()">ファイル選択</vs-button>
            </div>
          </vs-col>
          <vs-col vs-w="8.75">
            <div style="display: inline-block" @click="isRead ? downloadAttachment(file.file_name):''" v-for="(file, index) in Object.values(files)" :key="index" :class="{'cursor-pointer':isRead}">
              <vs-chip class="mt-1 mr-1" color="dark" transparent :closable="!isRead" @click="removeFile(index)">{{file.file_name.split('/').reverse()[0] | convertFileNameSend}}</vs-chip>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <!-- body, subject -->
      <div class="pt-10 card-subject">
        <div class="flex-wrap items-center justify-start card-title">
          <span class="pl-2">件名</span>
        </div>
        <div>
<!--          <vs-input v-if="!isRead" v-model="mailSubject" maxlength="512" class="w-full"/>-->
          <vs-textarea v-if="!isRead" v-model="mailSubject"></vs-textarea>
          <div v-else class="w-full div-subject" v-html="mailSubject"></div>
        </div>
        <div class="card-title">
          <span class="pl-2">メール本文</span>

          <vs-col vs-w="10.25" class="pl-2 flex flex-wrap items-center justify-start flex-row">
            <!----Dropdown mail template list---->
            <vs-dropdown vs-custom-content vs-trigger-click :disabled="isRead">
              <div class="pl-2">
                <vs-button :disabled="isRead" color="darkgray">テンプレート一覧</vs-button>
              </div>
              <vs-dropdown-menu class="mail-template-list-dropdown">
                <h5>テンプレート</h5>
                <vs-divider/>
                <div class="mail-template-list">
                  <div class= "template-item" v-for="template in listMailTemplate" :key="template.id" >
                    <vs-dropdown-item @click="displayTemplate(template.id)">  
                      <span >{{template.template_name}}</span>
                    </vs-dropdown-item>
                    <vs-icon icon="close" @click="deleteTemplate(template.id)"></vs-icon>
                  </div>
                </div>
              </vs-dropdown-menu>
            </vs-dropdown>
            <!---------Save template-------->
            <div class="pl-2">
              <vs-button :disabled="isRead" color="darkgray" @click="popupAdd=true" >テンプレート保存</vs-button>
                <vs-popup id="dialogDelete" title="テンプレートの新規作成" :active.sync="popupAdd">
                  <div>
                    <p class='my-2'>テンプレート名</p>
                    <vs-input label-placeholder="新規" v-model="templateName"/>
                  </div>
                  <div class="flex justify-end mt-4">
                      <vs-button @click="hidePopupAddMail()" icon="cancel" color="lightgrey" class="mx-2">キャンセル</vs-button>
                      <vs-button icon="save" color="primary" @click="addTemplate()">テンプレートとして保存</vs-button>
                  </div>
              </vs-popup>
            </div>
            <div class="pl-2">
              <vs-button :disabled="isRead" color="darkgray" @click="popUpSignature = true" >署名ボタン</vs-button>
                <vs-popup title="署名一覧" :active.sync="popUpSignature">
                  <div>
                    <ag-grid-vue
                      id="myGridSignature"
                      :gridOptions="gridOptionsSignature"
                      class="ag-theme-material w-100 my-4 ag-grid-table database"
                      :columnDefs="columnDefsSignature"
                      :defaultColDef="defaultColDef"
                      :rowData="listUserSignatureComputed"
                      rowSelection="single"
                      colResizeDefault="shift"
                      :animateRows="true"
                      :pagination="false"
                      :domLayout="domLayout"
                      @grid-ready="onGridReadySignature"
                      @selection-changed="onSelectionChangedSignature"
                      :suppressPaginationPanel="true"
                      :overlayNoRowsTemplate="noRowsTemplate"
                      :detailRowAutoHeight="true"
                    ></ag-grid-vue>
              </div>
              <div class="flex justify-end">
                <vs-button :disabled="!signatureSelect && signatureSelect != ''" @click="applySignature" color="success"  style="padding: 8px; margin-right: 5px;height: 37px">テキストを挿入</vs-button>
                <vs-button @click="popUpSignature = false" color="lightgrey" icon="cancel" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
              </div>
              </vs-popup>
            </div>
          </vs-col>
        </div>
        <div class="div-show-receive-mail" :class="{'border-box-all':!modeHTML}">
          <v-select class="float-right relative z-10 rounded cursor-pointer"  @input="changeModeHTML"  :reduce="bodyType => bodyType.value" :value="modeHTML" label="label" :options="bodyType"></v-select>
            <!-- <select :disabled="isRead"  @input="changeModeHTML" :value="modeHTML" class="float-right relative z-10 rounded cursor-pointer">
             <option class="mode-option" v-for="select in bodyType" :value="select.value">{{ select.label }}</option>
            </select> -->
          <vue2-tinymce-editor id="tinymceMessage" ref="tinymceEditor"  @editorInit="onEditorInit" :disabled="isRead"  v-model="mailMessage" v-if="modeHTML" :options="editorOption"></vue2-tinymce-editor>
          <vs-textarea id="textMessage"  ref="textMessage" class="text-Message" :disabled="isRead" v-else v-model="mailMessage" placeholder="" height='560px'></vs-textarea>
          <!-- <div class="ml-2 show-receive-mail">
            <div class="w-6 h-4 cursor-pointer z-10 bg-grey-light flex items-center justify-center rounded-full hover: button-active-show-receive-mail" @click="activeShow = !activeShow">
              <span class="pb-2 font-bold">...</span>
            </div>
            <vs-card class="mt-1" v-if="activeShow">
              <div v-html="receive_mail.body"></div>
            </vs-card>
          </div> -->
        </div>
      </div>
      <!-- dialog confirm changeMode HTML-->
    <vs-popup ref="dialogConfirm" title="テキストモードに切り替え" :active.sync="activeChangeModeHTML" button-close-hidden>
        <div>
          <span>
            テキストモードに切り替えると、このメッセージのすべての書式設定とインライン画像が削除されます。
          </span>
          <br>
          <span>続けますか？</span>
        </div>
        <div class="flex justify-end">
            <vs-button @click="modeHTML = false;activeChangeModeHTML = false" color="success" icon="check" style="padding: 8px; margin-right: 5px;height: 37px">はい</vs-button>
            <vs-button @click="activeChangeModeHTML = false" color="lightgrey" icon="cancel" style="padding: 8px; margin-right: 5px;height: 37px">キャンセル</vs-button>
        </div>
      </vs-popup>

  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import vSelect from 'vue-select'
import { Vue2TinymceEditor } from "vue2-tinymce-editor";
import {tinymceOptions, setupLanguageTinymce, focusAtBrLine, notifyEmptyReceive} from "@/utils/helpler-utils";
import {mapActions, mapGetters} from 'vuex'
import {getColumnLimit, getMaximumSizeAttachment} from '../utils/settings';
import { getLS, storeLS } from '../utils/localStorage-utils';
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/vuexy/components/view/receivedMailDetail.scss";
import { AgGridVue } from "ag-grid-vue";
import htmlToFormattedText  from 'html-to-formatted-text';
import {Html5Entities} from "html-entities";
import {htmlToText} from "html-to-text";
import PopupConfirm  from '../components/PopupConfirm.vue';
import Contacts  from '../components/Contacts.vue';
import EventBus from "../EventBus";
import Papa from 'vue-papa-parse';

export default {
  components: { 
    Vue2TinymceEditor,
    vSelect,
    AgGridVue,
    htmlToFormattedText,
    Html5Entities,
    htmlToText,
    PopupConfirm,
    Contacts
 },
  data() {
    return {
      readOnly: false,
      clickBack : false,
      originalTemplate: "-----Original Message-----",
      htmlOriginalTemplate: "-----Original&nbsp;Message-----",
      HTMLModeSplitLine: "<p>",
      bodyType : [
        {
          label : 'Text 形式',
          value : false
        },
        {
          label : 'HTML 形式',
          value : true
        }
      ],
      receive_mail: {},
      countReplyMail: null,
      activeSend      : false,
      activeShow      : false,
      isRead          : false,
      isReport        : false,
      viewMailSent    : false,
      viewMailDraft   : false,
      prevRoute       : '',
      mailTo          : '',
      mailCC          : '',
      mailBCC         : '',
      mailFrom        : '',
      inquiryType     : {value: 0, label: 'メール'},
      type            : {
        
      },
      listMstUserSelect: [
        ''
      ],
      mst_user        : {

      },
      state_flg        : {

      },
      to: null,
      cc: null,
      bcc: null,
      listTypeSelect  : [
        ''
      ],
      listInquiryTypeSelect: [
        {value: 0, label: 'メール'},
        {value: 1, label: '電話'},
        {value: 2, label: '営業'},
        {value: 9, label: 'その他'}
      ],
      listMailFrom    : [], // using in report-mail
      listMailTo      : [],
      listMailCC      : [],
      listMailBCC     : [],
      sendlistMailTo  : [],
      sendlistMailCC  : [],
      files           : [],
      mailSubject     : '',
      mailMessage     : '',
      sentDateTime    : null,
      confirmSendWithoutSubject: false,
      confirmSendWithoutBody: false,
      modeHTML        : false,
      activeChangeModeHTML: false,
      isCreated: false,
      messageError    : '',
      tinymceEditor: null,
      initialContentEditor: '',
      editorOption: tinymceOptions,

      //dialog confirm mail-send without body or subject
      confirmQuestion: '',
      titleDialog: '',

      //dialog add template
      popupAdd: false,
      templateName: '',

      //Bulk mode
      bulkMode: false,

      //CSV file
      csv_file : null,  // for handle file
      csv_data: null,   // for handle json data
      csv_header: null, // for handle headers
      csv_raw: null,    // for handle render table
      listSettings: [],     // settings for CSV

      //Shachihata desk
      isEmbedded: this.$route.query.mode && this.$route.query.mode == 'sdsk',
      isShachihataDesk: this.$route.query.mode && this.$route.query.mode == 'shachihatadesk',
      //AG gird
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: "autoHeight",
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ["asc", "desc"],
      },
      //Signature
      gridApiSignature: null,
      columnApiSignature: null,
      popUpSignature: false,
      gridOptionsSignature: {
        onGridSizeChanged: () => {
          this.gridApiSignature.sizeColumnsToFit();
        },
      },
      columnDefsSignature:[
        {
          headerName: "",
          width: 50,
          checkboxSelection: true,
        },
        {
          headerName: "名前",
          field: "signature_name",
          width: 100,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "署名",
          field: "parsed_signature",
          width: 300,
          unSortIcon: true,
          suppressMovable: true,

        },
      ],
      signatureSelect: null,
      currentCursor: null,
      //
      isSendInNewTab: false,
      //
      updateMailDraft: null,
      isSetPreviousMail: false,
      isClickCloseButton: false,
      //Close Current Tab
      activeModelCloseTab: false,
      activeModelContacts: false,
      typeModalContact:'',
      showIconContacts: false,
      oldValMailMessage: '',
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  watch: {
    modeHTML(){
      if (this.isCreated){
        this.changeMessage();
      }
    },
    // mailFrom(val){
    //   if(this.isReport && this.$route.path.search(val) === -1){
    //     document.getElementById(`router-link-item-/box/${this.mailFrom}`).setAttribute('class', 'router-link-exact-active router-link-active')
    //   }
    // }
    mailFrom(val){
      if(this.isReport && this.$route.path.search(val) === -1){
        let url = new URL(window.location.href);
        let close = url.searchParams.get("back");
        if (close){
          this.$store.commit('receiveMail/SET_CURRENT_MAIL_BOX_SELECT', val)
          this.$router.push(`/sent/${val}/create-mail?back=true`)
        }else{
          this.$store.commit('receiveMail/SET_CURRENT_MAIL_BOX_SELECT', val)
          this.$router.push(`/sent/${val}/create-mail`)
        }
        this.autoSaveMailDraft();
      }
    },
    listMailTo(newVal, oldVal) {
      this.listMailTo.forEach(to => {
        let toValue = to.split(";");
        if (toValue && toValue.length > 1) {
          this.listMailTo = this.listMailTo.filter(mail => mail !== to);
          toValue.forEach(value => {this.listMailTo.push(value)});
        }
      });
      newVal.forEach(value => {
        let emailExists = this.sendlistMailTo.some(function(emailto) {
          if (emailto.includes(value)) {
            return true;
          }
        });
        if (!emailExists) {
          this.sendlistMailTo.push(value);
        }
      });
    
      if ((oldVal && oldVal.length > 0) || this.updateMailDraft){
        this.autoSaveMailDraft();
      }
      let listMailToUpdate = this.listMailTo.filter(item => {
        return (item !== '' && item !== ' ')
      })
      if (listMailToUpdate.length !== this.listMailTo.length) {
        this.listMailTo = listMailToUpdate
      }
      this.$refs.vsChipTo.newChip = "";
       this.$nextTick(() => {
        let vschipsTo = document.getElementById('vschipsTo').clientHeight;
        document.getElementById('contacts_dropdown').style.top = vschipsTo + 'px';
      });
    },
    listMailCC(newVal, oldVal) {
      this.listMailCC.forEach(cc => {
        let ccValue = cc.split(";");
        if (ccValue && ccValue.length > 1) {
          this.listMailCC = this.listMailCC.filter(mail => mail !== cc);
          ccValue.forEach(value => {this.listMailCC.push(value)});
        }
      });
      newVal.forEach(value => {
        let emailExists = this.sendlistMailCC.some(function(emailcc) {
          if (emailcc.includes(value)) {
            return true;
          }
        });
        if (!emailExists) {
          this.sendlistMailCC.push(value);
        }
      });
      if ((oldVal && oldVal.length > 0) || this.updateMailDraft){
        this.autoSaveMailDraft();
      }
      let listMailCCUpdate = this.listMailCC.filter(item => {
        return (item !== '' && item !== ' ')
      })
      if (listMailCCUpdate.length !== this.listMailCC.length) {
        this.listMailCC = listMailCCUpdate
      }
      this.$refs.vsChipCc.newChip = "";
      this.$nextTick(() => {
        let vschipsCc = document.getElementById('vschipsCc').clientHeight;
        document.getElementById('contacts_dropdown_cc').style.top = vschipsCc + 'px';
      });
    },
    listMailBCC(newVal, oldVal) {
      this.listMailBCC.forEach(bcc => {
        let bccValue = bcc.split(";");
        if (bccValue && bccValue.length > 1) {
          this.listMailBCC = this.listMailBCC.filter(mail => mail !== bcc);
          bccValue.forEach(value => {this.listMailBCC.push(value)});
        }
      });
      if ((oldVal && oldVal.length > 0) || this.updateMailDraft){
        this.autoSaveMailDraft();
      }
      let listMailBCCUpdate = this.listMailBCC.filter(item => {
        return (item !== '' && item !== ' ')
      })
      if (listMailBCCUpdate.length !== this.listMailBCC.length) {
        this.listMailBCC = listMailBCCUpdate
      }
      this.$refs.vsChipBcc.newChip = "";
      this.$nextTick(() => {
        let vsChipBcc = document.getElementById('vschipsBcc').clientHeight;
        document.getElementById('contacts_dropdown_bcc').style.top = vsChipBcc + 'px';
      });
    },
    files(newVal, oldVal){
      if ((oldVal && oldVal.length > 0) || this.updateMailDraft){
        this.autoSaveMailDraft();
      }
    },
    inquiryType(newVal, oldVal){
      if (oldVal != 0 || this.updateMailDraft){
        this.autoSaveMailDraft();
      }
    },
    type(newVal, oldVal){
      if (oldVal != 0  || this.updateMailDraft){
        this.autoSaveMailDraft();
      }
    },
    mst_user(newVal, oldVal){
      if (oldVal != 0  || this.updateMailDraft){
        this.autoSaveMailDraft();
      }
    },
    mailMessage(newVal, oldVal){
      if(['shachihatadesk', 'shachihatadeskopener'].includes(this.$route.query.mode) && oldVal && this.oldValMailMessage == ''){
        let mailMessageHTML = '';
        let mailMessageText = '';
        if (this.receive_mail.body_type == 1) { // body type TEXT
          // convert text to html
          mailMessageHTML = oldVal.replaceAll('<', '&lt;').replaceAll('>', '&gt;');
          mailMessageHTML = this.convertTextToHtml(mailMessageHTML);
          mailMessageHTML = Html5Entities.encode(mailMessageHTML)
          mailMessageHTML = mailMessageHTML.split('\n').join('\n<br/>').split(' ').join('&nbsp;') + '<p><br></p>'
        } else {
          mailMessageHTML = this.initialContentEditor;
        }
        // convert html to text
        mailMessageText = mailMessageHTML.split('<br />').join("<br>")
        mailMessageText = mailMessageText.split('<p><span>').join("<p>").split('</span></p>').join("</p>")
        mailMessageText = mailMessageHTML.split('<p><br>').join("\n")
        mailMessageText = mailMessageText.split(' </p>').join("</p>")
        mailMessageText = mailMessageText.split('&nbsp;&nbsp;</p>').join("</p>")
        mailMessageText = mailMessageText.split('&nbsp;</p>').join("</p>")
        mailMessageText = mailMessageText.split('</p>\n<p>').join("</p><p>")
        mailMessageText = mailMessageText.split('&nbsp;&nbsp;\n').join("\n").split('&nbsp;\n').join("\n")
        mailMessageText = htmlToFormattedText(mailMessageText)
        mailMessageText = Html5Entities.decode(mailMessageText)
        this.oldValMailMessage = mailMessageText;
      }
      if (oldVal != 0 || this.updateMailDraft){
        this.autoSaveMailDraft();
      }
    },
    mailSubject(newVal, oldVal){
      if (oldVal !== '' || this.updateMailDraft){
        this.autoSaveMailDraft();
      }
    },
    bulkMode(newVal, oldVal){
      if(!newVal){
        this.$nextTick(() => {
          //Start process contacts dropdown
          this.styleContactListDropdown('contacts_dropdown',"vschipsTo");
          this.styleContactListDropdown('contacts_dropdown_cc',"vschipsCc");
          this.styleContactListDropdown('contacts_dropdown_bcc',"vschipsBcc");
          //End process contacts dropdown
        })
      }
    },
  },
  computed: {
    ...mapGetters({
      mailThreadView: 'receiveMail/getMailThreadView',
      mailDetail: 'receiveMail/mailDetail',
      listMailTemplate: 'templateMail/listMailTemplate',
      listUserSignature: "userSignature/listUserSignature",
      preMailDraft: "mailDraft/preMailDraft",
      listMailBox: "receiveMail/listMailBox",
      listContactComputed: 'contact/getContactList',
    }),
    splitLine() {
      return this.modeHTML ? this.HTMLModeSplitLine : "\n";
    },
    validateForm() {
      if (this.inquiryType.label == undefined) {
        this.messageError = "方法は必須です。";
        return false;
      }
      if(this.type.label == undefined){
        this.messageError = '種別は必須です。'
        return false
      }
      // Email To is required
      if(!this.bulkMode && this.listMailTo.length == 0 && this.mailTo == '' && this.to == null){
        this.messageError = 'Toは必須です。'
        return false
      }
      // validateEmail in listMail
      if(!this.bulkMode && this.listMailTo.length > 0){
        let to = this.listMailTo.find(to => this.validateEmail(to) == false)
        if(to) {
          this.messageError = 'メールアドレス形式が正しくありません。'
          return false
        }
      }
      if(this.listMailCC.length > 0){
        let cc = this.listMailCC.find(cc => this.validateEmail(cc) == false)
        if(cc){
          this.messageError = 'メールアドレス形式が正しくありません。'
          return false
        }
      }
      if(this.listMailBCC.length > 0){
        let bcc = this.listMailBCC.find(bcc => this.validateEmail(bcc) == false)
        if(bcc){
          this.messageError = 'メールアドレス形式が正しくありません。'
          return false
        }
      }

      // validateEmail on input: if not press 'enter' to add listMail
      if(!this.bulkMode && this.mailTo && !this.validateEmail(this.mailTo)) {
        this.messageError = 'メールアドレス形式が正しくありません。'
        return false
      }
      if(this.mailCC && !this.validateEmail(this.mailCC)){
        this.messageError = 'メールアドレス形式が正しくありません。'
        return false
      }
      if(this.mailBCC && !this.validateEmail(this.mailBCC)){
        this.messageError = 'メールアドレス形式が正しくありません。'
        return false
      }

      //check attach files length > 1 && file size
      // if(this.files.length > 1){
      //   this.messageError = '添付ファイルが多くて、圧縮ファイルにしてください。'
      //   return false
      // }
      let totalSize = 0
      let maxSize = parseInt(getMaximumSizeAttachment(this.listSettings));
      this.files.forEach(file => totalSize += file.size)
      if(totalSize > maxSize*1024*1024){
        this.messageError = 'ファイル容量は'+maxSize+'MB以下でアップロードしてください。';
        return false
      }
      if (!this.inquiryType || (this.inquiryType && this.inquiryType.label == "...")) {
        this.messageError = '方法をご選択ください。'
        return false
      }
      if (!this.type || (this.type && this.type.label == "...")) {
        this.messageError = '種別をご選択ください。'
        return false
      }
      if (!this.mst_user || (this.mst_user && this.mst_user.value == "")) {
        this.messageError = '担当者をご選択ください。'
        return false
      }
      if (this.mailSubject.length > 512) {
        this.messageError = '件名は512文字以下で指定ください。'
        return false
      }

      this.messageError = ''
      return true
    },

    validateTemplate() {
      if (this.templateName == ''){
        this.messageError = 'テンプレート名を入力してください。';
        return false;
      } else if (this.mailMessage == ''){
        this.messageError = 'テンプレートの内容を入力してください。';
        return false;
      }

      this.messageError = '';
      return true;
    },
    listUserSignatureComputed(){ 
      let listUserSignature = [];
      this.listUserSignature.forEach((element) => {
        listUserSignature.push(
          Object.assign({ ...element, parsed_signature: element.parsed_signature })
        );
      });
      return listUserSignature;
    }
  },
  mounted () {
    // //Start process contacts dropdown
    this.styleContactListDropdown('contacts_dropdown',"vschipsTo");
    this.styleContactListDropdown('contacts_dropdown_cc',"vschipsCc");
    this.styleContactListDropdown('contacts_dropdown_bcc',"vschipsBcc");
    // //End process contacts dropdown

    if(this.isReport) {
      window.addEventListener('popstate', this.onBack);
    }

    const root = this
    window.addEventListener('beforeunload', function(){
      sessionStorage.setItem("currentMailBox", root.prevRoute.params.email)
      const originalTextIndex = root.getOriginalTextIndex(root.mailMessage)
      if ((!root.isClickCloseButton && root.isReport) || (!root.isClickCloseButton && root.$route.name === 'reply-mail')){
        let listTo = root.listMailTo.map(mail => mail)
        if(root.mailTo) {
          listTo = listTo.concat(root.mailTo.split(";"));
        } 
        let listCC = root.listMailCC.map(mail => mail)
        if(root.mailCC) {
          listCC = listCC.concat(root.mailCC.split(";"));
        } 
        let listBCC = root.listMailBCC.map(mail => mail)
        if(root.mailBCC) {
          listBCC = listBCC.concat(root.mailBCC.split(";"));
        }
        let mailData = {
            body_type    : root.modeHTML,
            to      : listTo,
            from    : root.mailFrom,
            subject : root.mailSubject,
            body    : root.mailMessage,
            cc      : listCC,
            bcc     : listBCC,
            files   : root.files,
            inquiry_type: root.inquiryType.value,
            type : root.type.value,
            mst_user_id : root.mst_user.value,
            mail_type : 'draft',
        }
        if( root.$route.params.send_mail_id ) mailData['id'] = parseInt(root.$route.params.send_mail_id)
        else{
          if (root.updateMailDraft){
            mailData['id']  = root.updateMailDraft
          }
        }
        localStorage.setItem('dataSaveDraft' , JSON.stringify(mailData));
        localStorage.setItem('refreshPage' , 'draft');
      }
    })
    for(let index = 0; index < document.getElementsByClassName('con-chips--input').length; index++){
      document.getElementsByClassName('con-chips--input')[index].addEventListener('input', function() {
        let valueInput = document.getElementsByClassName('con-chips--input')[index].value
        if (valueInput.length > 0) {
          valueInput = valueInput.trimStart()
          // valueInput = valueInput.replaceAll('\t','')
          document.getElementsByClassName('con-chips--input')[index].value = valueInput
        }
        if(index == 0){
          root.mailTo = document.getElementsByClassName('con-chips--input')[index].value
        }
        if(index == 1){
          root.mailCC = document.getElementsByClassName('con-chips--input')[index].value
        }
        if(index == 2){
          root.mailBCC = document.getElementsByClassName('con-chips--input')[index].value
        }
      });
    }
    for(let index = 0; index < document.getElementsByClassName('con-chips--input').length; index++){
      document.getElementsByClassName('con-chips--input')[index].addEventListener('blur', function() {
        let valueInput = document.getElementsByClassName('con-chips--input')[index].value
        if (valueInput.length > 0) {
          valueInput = valueInput.trim()
          // valueInput = valueInput.replaceAll('\t','')
          document.getElementsByClassName('con-chips--input')[index].value = valueInput
        }
        if(index == 0){
          root.mailTo = document.getElementsByClassName('con-chips--input')[index].value
        }
        if(index == 1){
          root.mailCC = document.getElementsByClassName('con-chips--input')[index].value
        }
        if(index == 2){
          root.mailBCC = document.getElementsByClassName('con-chips--input')[index].value
        }
      });
    }
    EventBus.$on("applyContactsTo", (listMailToSelected,typeModalContact) => {
      const regexMail = /<([^<>]+?)>/;
      let listSelectedMail = listMailToSelected.map(email => regexMail.exec(email)[1]);
      if (typeModalContact === 'TO') {
        this.listMailTo = this.removeDuplicates([...this.listMailTo, ...listSelectedMail]);
        this.sendlistMailTo = this.removeDuplicates([...this.sendlistMailTo, ...listMailToSelected]);
      } else if (typeModalContact === 'CC') {
        this.listMailCC = this.removeDuplicates([...this.listMailCC, ...listSelectedMail]);
        this.sendlistMailCC = this.removeDuplicates([...this.sendlistMailCC, ...listMailToSelected]);
      } else if (typeModalContact === 'BCC') {
        this.listMailBCC = this.removeDuplicates([...this.listMailBCC, ...listSelectedMail]);
      }
    });
    EventBus.$on("disableModelContacts", () => {
      this.activeModelContacts = false
      this.typeModalContact = '';
    });
    setupLanguageTinymce();
  },
  methods: {
    ...mapActions({
      replyMail: 'moduleEmail/replyMail',
      createMail: 'moduleEmail/createMail',
      getMailReceive: 'receiveMail/getReceiveMailDetail',
      getListThread: 'receiveMail/getListThread',
      downloadFile: "receiveMail/downloadAttachment",
      getMailSent: 'moduleEmail/getMailSent',
      getListMailBoxSend: 'receiveMail/getListMailBoxSend',
      getListMailBox: 'receiveMail/getListMailBox',
      getListKinds: 'kinds/getListKinds',
      getListMailTemplate: 'templateMail/getListMailTemplate',
      deleteMailTemplate: 'templateMail/deleteMailTemplate',
      addMailTemplate: 'templateMail/addMailTemplate',
      getListSettings: 'settings/getListSettings',
      handleShachihataDeskLogin: 'loginModule/handleShachihataDeskLogin',
      getUserSignature: "userSignature/getUserSignature",
      saveMailDraft: "mailDraft/saveMailDraft",
      getListUserDataSelect: "receiveMail/getListUserDataSelect",
      fetchContactList: "contact/fetchContactList",
      setUserReadOnly: "receiveMail/setUserReadOnly",
      updateMailReceivedUser: 'receiveMail/updateMailReceivedUser',
    }),
    styleContactListDropdown(contactsDropdownId, vschipsId){
      //Start process contacts dropdown
          let concChipsTo = document.querySelector('#'+vschipsId+'>.con-chips')
          concChipsTo.style.paddingRight = '45px';
          let contactsDropdown = document.getElementById(contactsDropdownId)
          contactsDropdown.style.display = 'none';
          setTimeout(() => {
            contactsDropdown.style.maxHeight = '114px'
            contactsDropdown.style.overflowY = 'scroll'
          }, 20)
          let conChipsInputTo = document.querySelector('#'+vschipsId+'>.con-chips>.con-chips--input')
          conChipsInputTo.addEventListener('input', function() {
            let search = conChipsInputTo.value.toLowerCase();
            if(search != '') {
              contactsDropdown.style.display = 'block';
            } else {
              contactsDropdown.style.display = 'none';
            }
            let lists = document.querySelectorAll('#'+contactsDropdownId+'>li');
            const listsLen = lists.length;
            let totalContactsShow = 0
            for (let i = 0; i < listsLen; ++i) {
              const listContent = lists[i].textContent.toLowerCase();
              if (listContent.indexOf(search) > -1) {
                lists[i].style.display = 'block';
                totalContactsShow++
              } else {
                lists[i].style.display = 'none';
              }
            }
            if(!totalContactsShow) {
              contactsDropdown.style.display = 'none';
            }
          })

          document.addEventListener('click', function handleClickOutsideBox(event) {
            if (!contactsDropdown.contains(event.target)) {
              contactsDropdown.style.display = 'none';
            }
          });

          contactsDropdown.addEventListener('click', () => {
            contactsDropdown.style.display = 'none';
            conChipsInputTo.value = '';
            conChipsInputTo.focus();
          });
          //End process contacts dropdown
    },
    contactSelected(contact,typeContact) {
      if (typeContact === 'TO') {
        this.listMailTo = this.removeDuplicates([...this.listMailTo, contact]);
        this.sendlistMailTo = this.removeDuplicates([...this.sendlistMailTo, contact]);
      } else if (typeContact === 'CC') {
        this.listMailCC = this.removeDuplicates([...this.listMailCC, contact]);
        this.sendlistMailCC = this.removeDuplicates([...this.sendlistMailCC, contact]);
      } else if (typeContact === 'BCC') {
        this.listMailBCC = this.removeDuplicates([...this.listMailBCC, contact]);
      }
    },
    showListContact(type) {
      this.$nextTick(() => {
        this.typeModalContact = type;
        this.activeModelContacts = true
      });
    },
    setSelRange(inputEl, selStart, selEnd) {
      if (inputEl.setSelectionRange) {
        inputEl.focus();
        inputEl.setSelectionRange(selStart, selEnd);
      } else if (inputEl.createTextRange) {
        var range = inputEl.createTextRange();
        range.collapse(true);
        range.moveEnd('character', selEnd);
        range.moveStart('character', selStart);
        range.select();
      }
    },
    handleFiles(Event){
      const toBase64 = file => new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
      });
      let fileInput = Object.values(Event.target.files);
      fileInput.forEach(file =>{
        if (file.size == 0){
          this.$vs.notify({
            position: 'bottom-right',
            text: file.name+'ファイル容量が0となっているので、添付できません。',
            color: 'danger'
          })
          this.$refs.files.value = '';
        } else {
          toBase64(file).then(res => {
            let maxSize = parseInt(getMaximumSizeAttachment(this.listSettings));
            if (file.size > maxSize*1024*1024) throw 'ファイル容量は'+maxSize+'MB以下でアップロードしてください。';
            let pos = res.indexOf("base64,");
            res = res.substring(pos+7);
            let fileEncode = {
              "file_name": file.name,
              "mime": file.type,
              "file_content": res,
              "size": file.size
            }
            if (!this.isDuplicateFile(fileEncode)) {
              this.files.push(fileEncode);
            }
          })
          .catch(err =>{
            this.$vs.notify({
              position: 'bottom-right',
              text: err.target ? err.target.error : err,
              color: 'danger'
            })
          })
          this.$refs.files.value = '';
        }  
      })
    },
    isDuplicateFile(fileEncode){
      return this.files.some((existingFileEncode) => {
        return existingFileEncode.file_name === fileEncode.file_name && existingFileEncode.mime === fileEncode.mime && existingFileEncode.file_content === fileEncode.file_content;
      });
    },
    async downloadAttachment(file) {
      let data = {
        "id" : this.$route.params.send_mail_id,
        "fileName" : file,
      }
      let result = await this.downloadFile(data);
      if (result) {
          const content = result.file_data;
          let fileName = result.file_name;
          let typeDownload = result.file_type;
          // Decode base64 using atob method
          let data = window.atob(content);
          let bytes = new Array(data.length);
          for (let i = 0; i < data.length; i++) {
              bytes[i] = data.charCodeAt(i);
          }
          data = new Uint8Array(bytes);
          let anchor = document.createElement('a');
          if (anchor.download !== undefined) {
            let blob = new Blob([data], {type: typeDownload});
            var objectURL = window.URL.createObjectURL(blob);

            anchor.href = objectURL;
            anchor.download = fileName;
          }
          if (navigator.msSaveBlob) { // IE 10+
            anchor.addEventListener("click", function (event) {
              let blob = new Blob([data], {
                "type": 'text'
              });
              navigator.msSaveBlob(blob, fileName);
            }, false);
          }

          anchor.click();

          URL.revokeObjectURL(objectURL);
      }
    },
    removeFile(index){
      this.files.splice(index,1);
    },
    getOriginalTextIndex(body) {
      let originalTextIndex = 0;
      let splitLine = this.splitLine
      if(body.split(splitLine).length < 6 && splitLine == '<br/>') {
        splitLine = '<p>'
        this.HTMLModeSplitLine = splitLine
      }
      const condition = (element) =>
        element == this.originalTemplate ||
        element == this.htmlOriginalTemplate ||
        element.includes(this.originalTemplate) ||
        element.includes(this.htmlOriginalTemplate)

        originalTextIndex = body.split(splitLine).findIndex(condition);
      return originalTextIndex;
    },
    async onSaveDraft(action) {
      let url = new URL(window.location.href);
      let originalTextIndex = this.getOriginalTextIndex(this.mailMessage);
      // copy listMail => fix error duplicate
      let listTo = this.sendlistMailTo.map(mail => mail)
      if(this.mailTo) {
        listTo = listTo.concat(this.mailTo.split(";"));
      } 
      let listCC = this.sendlistMailCC.map(mail => mail)
      if(this.mailCC) {
        listCC = listCC.concat(this.mailCC.split(";"));
      } 
      let listBCC = this.listMailBCC.map(mail => mail)
      if(this.mailBCC) {
        listBCC = listBCC.concat(this.mailBCC.split(";"));
      }
      let receiveInquiryId = url.searchParams.get("receive-inquiry-id");
      let sentInquiryId = url.searchParams.get("sent-inquiry-id");
      let mailData = {
        body_type: this.modeHTML ? "HTML" : "Text",
        to: listTo,
        from: this.mailFrom,
        subject: this.mailSubject,
        body: this.mailMessage,
        cc: listCC,
        bcc: listBCC,
        files: this.files,
        inquiry_type: this.inquiryType.value,
        type: this.type && this.type.value ? this.type.value : null,
        mst_user_id:
          this.mst_user && this.mst_user.vaule ? this.mst_user.value : null,
        mail_type: "draft",
        receive_inquiry_id: this.$route.params.inquiry_id || receiveInquiryId || sentInquiryId,
        name_view_send: sentInquiryId ? 'mailsend':'',
      };

      if (action != "duplicate") {
        // For update
        if( this.$route.params.send_mail_id ) mailData['id'] = parseInt(this.$route.params.send_mail_id)
        else{
          if (this.updateMailDraft){
            mailData['id']  = this.updateMailDraft
          }
        }
      } else{
            mailData['id']  = null
            mailData['id_mail_draft']  = Number(this.$route.params.send_mail_id)
      }
      if ((this.inquiryType && this.inquiryType.value) || (this.type && this.type.value) ||
      listTo.length > 0 || listCC.length > 0 || listBCC.length > 0 ||
      this.files.length > 0 || this.mailSubject != '' || this.mailMessage != ''){
        localStorage.setItem('noLoading' , true);
        let success = await this.saveMailDraft(mailData)
        if (success) {
        this.updateMailDraft = success
        //Send postMessage
          if (this.$route.query.mode == 'sdsk') {
            this.sendPostMessage('save', true);
            return;
          }
          if (action == 'duplicate') {
            let close = url.searchParams.get("back");
            if (close) {
              let viewMailReply = url.searchParams.get("view-thread-mail");
              localStorage.setItem('statusSaveEmailBody', true)
              let setUrlReceiveId = `${viewMailReply ? 'receive-inquiry-id=' + this.$route.params.inquiry_id + '&view-thread-mail=true&':''}`;
              //view send reply mail
              if(!viewMailReply){
                const sentInquiryId = 'sent-inquiry-id=' + this.$route.params.send_mail_id + '&view-thread-mail=true&';
                const isViewMailSent = this.$route.name === 'view-mail-sent';
                setUrlReceiveId = isViewMailSent ? sentInquiryId : '';
              }
              location.href = `/draft/${this.$route.params.email}/${success}?${setUrlReceiveId}back=true`;
            } else {
              location.href = `/draft/${this.$route.params.email}/${success}`;
            }
          }
        } else {
          this.sendPostMessage('save', false);
        }
      }
    },
    async onSaveForwardDraft(action) {
      let originalTextIndex = this.getOriginalTextIndex(this.mailMessage);
      // copy listMail => fix error duplicate send forward
      let listTo = this.listMailTo.map(mail => mail)
      if(this.mailTo) {
        listTo = listTo.concat(this.mailTo.split(";"));
      }
      let listCC = this.listMailCC.map(mail => mail)
      if(this.mailCC) {
        listCC = listCC.concat(this.mailCC.split(";"));
      }
      let listBCC = this.listMailBCC.map(mail => mail)
      if(this.mailBCC) {
        listBCC = listBCC.concat(this.mailBCC.split(";"));
      }
      let mailData = {
        body_type: this.modeHTML ? "HTML" : "Text",
        to: listTo,
        from: this.mailFrom,
        subject: this.mailSubject,
        body: this.mailMessage,
        cc: listCC,
        bcc: listBCC,
        files: this.files,
        inquiry_type: this.inquiryType.value,
        type: this.type && this.type.value ? this.type.value : null,
        mst_user_id:
          this.mst_user && this.mst_user.vaule ? this.mst_user.value : null,
        mail_type: "draft",
      };

      if (action != "duplicate") {
        // For update
        if( this.$route.params.send_mail_id ) mailData['id'] = parseInt(this.$route.params.send_mail_id)
        else{
          if (this.updateMailDraft){
            mailData['id']  = this.updateMailDraft
          }
        }
      } else{
            mailData['id']  = null
            mailData['id_mail_draft']  = Number(this.$route.params.send_mail_id)
      }
      if ((this.inquiryType && this.inquiryType.value) || (this.type && this.type.value) ||
        listTo.length > 0 || listCC.length > 0 || listBCC.length > 0 ||
        this.files.length > 0 || this.mailSubject != '' || this.mailMessage != ''){
        localStorage.setItem('noLoading' , true);
        let success = await this.saveMailDraft(mailData)
        if (success) {
          this.updateMailDraft = success
          //Send postMessage
          if (this.$route.query.mode == 'sdsk') {
            this.sendPostMessage('save', true);
            return;
          }
          if (action == 'duplicate') {
            let url = new URL(window.location.href);
            let close = url.searchParams.get("back");
            if (close) {
              let viewMailReply = url.searchParams.get("view-thread-mail");
              localStorage.setItem('statusSaveEmailBody', true)
              let setUrlReceiveId = `${viewMailReply ? 'receive-inquiry-id=' + this.$route.params.inquiry_id + '&view-thread-mail=true&':''}`;
              //view send forward mail
              if(!viewMailReply){
                const sentInquiryId = 'sent-inquiry-id=' + this.$route.params.send_mail_id + '&view-thread-mail=true&';
                const isViewMailSent = this.$route.name === 'view-mail-sent';
                setUrlReceiveId = isViewMailSent ? sentInquiryId : '';
              }
              location.href = `/draft/${this.$route.params.email}/${success}/forward-mail?${setUrlReceiveId}send-forward=true&back=true`;
            } else {
              location.href = `/draft/${this.$route.params.email}/${success}`;
            }
          }
        } else {
          this.sendPostMessage('save', false);
        }
      }
    },
    async onSaveDraftDuplicate(){
      if ( !await this.checkMailReceiveActivity() ) return;
      await this.onSaveDraft('duplicate');
    },
    async onSaveDraftForwardDuplicate(){
      if ( !await this.checkMailReceiveActivity() ) return;
      await this.onSaveForwardDraft('duplicate');
    },
    beforeSendMail () {
      if(!this.validateForm){
        this.$vs.notify({
          position: 'bottom-right',
          text: this.messageError,
          color: 'danger'
        })
      }
      else{
        this.totalConfirmTime = 0
        if (this.mailSubject && this.mailMessage) {
          if(this.bulkMode) this.sendBulk();
          else this.send();
        } else {
          if (!this.mailSubject) {
            this.totalConfirmTime++
          }
          if (!this.mailMessage) {
            this.totalConfirmTime++
          }
          this.confirmDialogBeforeSend()
        }
      }
    },
    confirmDialogBeforeSend() {
      if(!this.mailSubject){
        this.confirmQuestion = '件名内容なしでメール送信しますか？'
        this.titleDialog = '件名内容確認'
        this.activeSend = true
      }
      else if(!this.mailMessage){
        this.confirmQuestion = '返信内容なしでメール送信しますか？'
        this.titleDialog = '返信内容確認'
        this.activeSend = true
      }
    },
    confirm() {
      this.totalConfirmTime--
      if (this.totalConfirmTime === 0) {
        if(this.bulkMode) this.sendBulk();
        else this.send();
      }
      if(this.totalConfirmTime > 0) {
        this.confirmQuestion = '返信内容なしでメール送信しますか？'
        this.titleDialog = '返信内容確認'
        this.activeSend = true
      }

    },
    getDifferenceInBody() {
      // get the difference content for shachihatadesk
      let oldTEXT = this.oldValMailMessage;
      let newTEXT = this.mailMessage;
      if(this.modeHTML){
        newTEXT = newTEXT.split('<br />').join("<br>")
        newTEXT = newTEXT.split('<p><br>').join("\n")
        newTEXT = newTEXT.split(' </p>').join("</p>")
        newTEXT = newTEXT.split('&nbsp;&nbsp;</p>').join("</p>")
        newTEXT = newTEXT.split('&nbsp;</p>').join("</p>")
        newTEXT = newTEXT.split('</p>\n<p>').join("</p><p>")
        newTEXT = newTEXT.split('&nbsp;\n').join("\n")
        newTEXT = htmlToFormattedText(newTEXT)
        newTEXT = Html5Entities.decode(newTEXT)  
      }else{
        newTEXT = newTEXT.split('\n').map(line => line.trimEnd()).join('\n');
        newTEXT = Html5Entities.decode(newTEXT)
      }
      let newString = newTEXT.replaceAll(oldTEXT.trim(), '');
      return newString.trim();
    },
    async send(){
      // copy listMail => fix error duplicate
      let listTo = this.listMailTo.map(mail => mail)
      if(this.mailTo) {
        listTo = listTo.concat(this.mailTo.split(";"));
      } 
      let listCC = this.listMailCC.map(mail => mail)
      if(this.mailCC) {
        listCC = listCC.concat(this.mailCC.split(";"));
      } 
      let listBCC = this.listMailBCC.map(mail => mail)
      if(this.mailBCC) {
        listBCC = listBCC.concat(this.mailBCC.split(";"));
      }
      let listSendTo = this.sendlistMailTo.map(mail => mail)
      if(this.mailTo) {
        listSendTo = listSendTo.concat(this.mailTo.split(";"));
      }
      let listSendCC = this.sendlistMailCC.map(mail => mail)
      if(this.mailCC) {
        listSendCC = listSendCC.concat(this.mailCC.split(";"));
      }

      // set data send
      let mailData = {
          body_type    : this.modeHTML ? 'HTML':'Text',
          to      : this.to != null ? [this.to] : listTo ,
          from    : this.mailFrom,
          subject : this.mailSubject,
          body    : this.mailMessage,
          cc      : listCC,
          bcc     : listBCC,
          files   : this.files,
          inquiry_type: this.inquiryType.value,
          type : this.type.value,
          mst_user_id : this.mst_user.value,
          delete_draft :  !this.viewMailDraft ? this.updateMailDraft : null,
          newTo  : this.to != null ? [this.to] : listSendTo,
          newCC  : listSendCC,
        }
        let url = new URL(window.location.href);
        let mailInquiryId = url.searchParams.get("receive-inquiry-id");
        let viewDraft = url.searchParams.get("view-draft");
        //support view mail receive send
        if(mailInquiryId){
          mailData.send_view_reply = viewDraft ? 'send_draft_reply' : 'send_reply_email';
          mailData.send_reply_inquiry = mailInquiryId;
        }
        //support view mail send
        let mailIdSent = url.searchParams.get("sent-inquiry-id");
        if(mailIdSent){
          mailData.sent_view_reply = viewDraft ? 'sent_draft_reply' : 'view_send_reply_email';
          mailData.sent_reply_inquiry = mailIdSent;
        }
        //sent from the draft screen
        let mailNameSent = url.searchParams.get("name_view_send");
        if(mailNameSent){
          mailData.name_view_send = mailNameSent;
        }
      // For update
      if( this.$route.params.send_mail_id ) mailData['id'] = parseInt(this.$route.params.send_mail_id)

      let success
      if (this.receive_mail.id) {
        mailData.mail_id = this.receive_mail.id
        success = await this.replyMail(mailData)
        if(!this.receive_mail.mst_user_id){
          let data = {
            id: this.receive_mail.id,
            state_flg: 0,
            response_limit: this.receive_mail.response_limit ? this.receive_mail.response_limit : '',
            type: this.receive_mail.type,
            mst_admin_id: this.receive_mail.mst_admin_id ? this.receive_mail.mst_admin_id : '',
            mst_user_id: this.mst_user.value,
            inquiry_type: this.receive_mail.inquiry_type ? this.receive_mail.inquiry_type : 0,
            priority: 0,
            folder : this.receive_mail.folder
          };
          await this.updateMailReceivedUser(data);
        }
        this.isSendInNewTab = true;
      } else {
        success = await this.createMail(mailData)
        this.isSendInNewTab = true;
      }

      if (success){
        if (['shachihatadesk', 'shachihatadeskopener'].includes(this.$route.query.mode) && this.oldValMailMessage) {
          let targetOrigin = '*';
          let matterId = '';
          let opener = this.$route.query.opener;
          if(this.$route.query.urlorigin){
            const matterDeskUrl = new URL(this.$route.query.urlorigin);
            targetOrigin = matterDeskUrl.href;
            matterId = matterDeskUrl.pathname.split('/').pop();
          }
          let diffData = this.getDifferenceInBody();
          let data = {
            type: opener ? 'pac21_send_opener' : 'pac21_send',
            from: window.location.origin +'/',
            inquiry_id: (opener && matterId) ? matterId : (this.receive_mail ? this.receive_mail.inquiry_id : ''),
            result: diffData
          }
          if(diffData){
            window[opener ? 'opener' : 'parent'].postMessage(data, targetOrigin)
          }
        }
        if (this.$route.query.mode == 'sdsk') {
          this.sendPostMessage('send', true);
          return;
        }
        this.onBack();
      } else {
        if (this.$route.query.mode == 'sdsk') {
          this.sendPostMessage('send', false);
          return;
        }
      }
    },
    closeCurrentTab() {
      this.activeModelCloseTab = false
      if (!this.isShachihataDesk) {
        window.close();
      }
    },
    validateEmail(emails) {
      if (emails.length > 0) {
        emails = emails.trim()
      }
      let success = true;
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let listEmails = emails.split(";");
      for (let i = 0; i < listEmails.length; i++) {
        if (!re.test(String(listEmails[i]).toLowerCase())) {
          success = false;
          break;
        }
      }
      return success;
    },
    async onBack() {
      let url = new URL(window.location.href);
      let close = url.searchParams.get("back");
      let viewThreadMail = url.searchParams.get("view-thread-mail");
      if (close){
        if (this.isReport && this.isSendInNewTab) {
          this.activeSend = false
          // set refreshPage = true  when close tab
          localStorage.setItem('refreshPage' , true);
          this.activeModelCloseTab = true
        }
        else{
          if (this.isSendInNewTab){
            // set refreshPage = true  when close tab
            localStorage.setItem('refreshPage' , true);
            this.activeModelCloseTab = true
          } else {
            if (this.isReport || this.$route.name === 'reply-mail'){
              await this.onSaveDraft();
              localStorage.setItem('refreshPage' , 'draft');
              this.isClickCloseButton = true;
            }
            if(this.viewMailDraft){
              if(Number(window.history.length) > 1) window.history.back();
              else window.close();
            } else {
              if (viewThreadMail){
                window.history.back();
              }else{
                window.close();
              }
            }
          }
        }
      }
      else{
        if(this.isReport){
          let url_box = this.mailFrom
          if(this.prevRoute && this.prevRoute.params.email) url_box = this.prevRoute.params.email
          else if(sessionStorage.getItem('currentMailBox')) url_box = sessionStorage.getItem('currentMailBox')
          if (this.viewMailDraft){
            await this.onSaveDraft();
            if(this.clickBack) {
              this.clickBack = false;
              this.$router.go(-1);
            } else {
              this.activeModelCloseTab = true
            }
            // await this.onSaveDraft();
            // this.$router.push(`/draft/${url_box}`);
          } else {
            this.$router.push(`/sent/${url_box}`);
          }
       }
      else {
        if (this.viewMailSent) {
          this.$router.push({path:`/sent/${this.$route.params.email}`});     
        }
        else if(this.viewMailDraft){
          this.$router.push({path:`/draft/${this.$route.params.email}`});
        } else {
          let routePath = `/box/${this.$route.params.email}/${this.$route.params.inquiry_id}?back=true`;
          if (this.$route.query.mode === 'shachihatadeskopener') {
            routePath += '&mode=shachihatadesk';
            if (this.$route.query.urlorigin) {
              routePath += `&urlorigin=${this.$route.query.urlorigin}`;
            }
          }
          this.$router.push({path: routePath});
        }
      }
      } 
    },

    buttonBack(){
      this.clickBack = true
      this.onBack()
    },

    //Mail template methods
    deleteTemplate: async function (id) {
      try {
        //Delete mail template
        await this.deleteMailTemplate({
        user_id: this.$store.state.AppActiveUser.id,
        id});
        //Update list mail template
        await this.getListMailTemplate({user_id: this.$store.state.AppActiveUser.id});
      } catch(error) {
        console.log(error);
      }
    },
    async getListKindsSelect() {
      let response = await this.getListKinds()
      if (response) {
        
        this.listTypeSelect = [
              {
                label: '...',
                value: ''
              }
        ]
        response.map(element => {
          let result = { }
          result.value = element.type_id
          result.label = element.kinds_name
          this.listTypeSelect.push(result)
        })
      } else {
        this.listTypeSelect = [
            {
              label: '...',
              value: ''
            }
        ]
      }
    },

    async getListSettingsSelect() {
      let response = await this.getListSettings()
      if (response) {
        this.listSettings = [];
        response.map(element => this.listSettings.push(element));
      } else {
        this.listSettings = [];
      }
    },
    async getListMstUserSelect() {
      let mailBoxInfo = await this.listMailBox.find(
        (element) => element.receive_user_name == this.$route.params.email
      );
      if (mailBoxInfo) {
        let params = {
          mst_mail_server_id: mailBoxInfo.id,
        };
        let response = await this.getListUserDataSelect(params);
        if (response) {
          this.listMstUserSelect = [
            {
              label: "...",
              value: "",
            },
          ];
          response.map((element) => {
            let result = {};
            result.value = element.id;
            result.label = element.full_name;
            this.listMstUserSelect.push(result);
          });
        } else {
          this.listMstUserSelect = [
            {
              label: "...",
              value: "",
            },
          ];
        }
      }
    },
    addTemplate: async function () {
      //Check template name and content
      if (!this.validateTemplate) {
        this.$vs.notify({
          position: 'bottom-right',
          text: this.messageError,
          color: 'danger'
        })
      } else {
        try {
          //Add mail template
          await this.addMailTemplate({
            user_id: this.$store.state.AppActiveUser.id,
            template_name: this.templateName,
            template_content: this.mailMessage,
            template_mode: this.modeHTML ? 1 : 0,
          });

          //Update list mail template
          await this.getListMailTemplate({user_id: this.$store.state.AppActiveUser.id});

          this.hidePopupAddMail();
        } catch(error) {
          console.log(error);
        }
      }
    },

    displayTemplate: function (id) {
      const template = this.listMailTemplate.filter(item => item.id == id);
      this.mailMessage = template[0].template_content;
      this.modeHTML = template[0].template_mode == 1;
      focusAtBrLine(this.tinymceEditor, this.$route.name);
    },
    hidePopupAddMail: function () {
      this.templateName = '';
      this.popupAdd = false;
    },

    //CSV Upload methods
    handleCSVFile(e){
      //Validate file input
      const file = e.target.files[0];
      if (file.name.split('.').pop() != 'csv') {
        this.messageError = "ファイルの形式はCSVファイルではありません。";
        this.$vs.notify({
          position: 'bottom-right',
          text: this.messageError,
          color: 'danger'
        });
        return;
      }
      
      const processCSVData = dataArr => {
        let keyArr = [], objects = [];
        this.csv_raw = [];
        //2D array with key (pos 0) and values (res)
        dataArr.map((row, index) => {
          if (index == 0) {
            keyArr = row;
            //Set csv_header
            this.csv_header = keyArr;
          }
          else {
            let object = {};
            this.csv_raw.push(row);
            row.map((value, idx) => {
              if (!object[keyArr[idx]]) object[keyArr[idx]] = value;
            });
            objects.push(object);
          }
        });
        this.csv_data = objects;
      };

      //Convert to json
      this.$papa.parse(file, {
        encoding: 'Shift_JIS',
        skipEmptyLines: true,
        delimiter: [',', '\t', '|', ';'],
        delimitersToGuess: [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP],
        complete: (results, file) => {
            try {
                const dataArr = results.data.filter((row) => row.length > 0);
                this.validateCSV(dataArr) && processCSVData(dataArr);
                //Set the name of csv file
                this.csv_file = file.name;
            } catch (error) {
                this.messageError = error;
                  this.$vs.notify({
                    position: 'bottom-right',
                    text: this.messageError,
                    color: 'danger',
                });
            }
        },
        error: (error) => {
            this.messageError = error;
            this.$vs.notify({
                position: 'bottom-right',
                text: this.messageError,
                color: 'danger'
            });
        },
      });
    },

    removeCSVFile(e){
      this.csv_file = null;
      this.csv_data = null;
      this.csv_header = null;
      this.csv_raw = null;
    },
    removeEmptyElements(data){
      if(data.length == 0) return data;
      return data.filter((item) => {
          return item !== null && item !== undefined && item !== "";
      });
    },
    validateCSV(dataArr) {
      const headerArr = dataArr[0];
      //Check column header
      if (headerArr.length > getColumnLimit(this.listSettings)) throw 'CSVファイルは無効です。制限の列数を超えました。';

      //Check column header not empty
      headerArr.map((ele, index) => {
        if (ele == '') throw `CSVファイルは無効です。#${index + 1}列のタイトルは空となっています。`;
      });

      const noCol = headerArr.length;
      //Check csv format
      dataArr.map((ele, index) => {
        //Check row is not empty
        if (ele == '') throw `CSVファイルは無効です。#${index + 1}行は空となっています。`;
        //Check column length
        if (ele.length != noCol) throw `CSVファイルは無効です。#${index + 1}行をチェックしてください。`;
      });

      //Check to column
      const toIdx = headerArr.findIndex(ele => /\bto\b/gi.test(ele));
     
      this.toHeader = null;
      if (toIdx != -1) {
        this.toHeader = headerArr[toIdx];
        //Check to column
        for (let i = 1; i < dataArr.length; i++) {
          const rowData = dataArr[i];
          if (!this.validateEmail(rowData[toIdx])) {
              throw `CSVファイルは無効です。TOアドレスが正しくありません。${headerArr[toIdx]}: ${rowData[toIdx]}（${i + 1}行目 ）`;
          }
        }
        return true;
      } else {
        throw `CSVファイルは無効です。TOアドレスを入力してください。`;
      }
    },

    //Bulk send method
    async sendBulk() {
      let url = new URL(window.location.href);
      let mailNameSent = url.searchParams.get("name_view_send");
      //Validate header in mail body
      const regex = /{([^}]+)}/g;
      const headers = this.mailMessage.match(regex);
      let isFailed = false;
      headers && headers.map(header => {
        if (this.csv_header.indexOf(header.replaceAll(/\{|\}/g,'')) == -1){
          this.messageError = header + "フィールドが見つかりません。";
          this.$vs.notify({
            position: 'bottom-right',
            text: this.messageError,
            color: 'danger'
          });
          isFailed = true;
        }
      });
      if (isFailed) return;
      
      let listCC = this.listMailCC.map(mail => mail)
      if(this.mailCC) {
        listCC = listCC.concat(this.mailCC.split(";"));
      } 
      let listBCC = this.listMailBCC.map(mail => mail)
      if(this.mailBCC) {
        listBCC = listBCC.concat(this.mailBCC.split(";"));
      }
      let listMailTo = [];
      let listPrefixMessage = [];
      //Loop through list csv_data
      let successAll = true;
      let bodyMsg = this.mailMessage.replace(/^(<p>\s*<\/p>\s*)+/i, '')
          .replace(/^(\s*<br\s*\/?>\s*)+/i, '')
          .replace(/<p>(\s*<br\s*\/?>\s*)+/gi, '<p>')
          .replace(/^\n<br\s*\/?\s*>\s*(?:<br\s*\/?\s*>\s*)+/, '')
          .replace(/^\n+/, '')
          .replace(/^(<p>(&nbsp;|\s|<br\s*\/?>)*<\/p>\s*)+/gi, '');
      for(let i = 0; i< this.csv_data.length; i++){
        const data = this.csv_data[i];
        //Parse mail message
        let infoCustomer = '';
        for (const key of ['企業名', '宛名']) {
            if (Object.hasOwnProperty.call(data, key)) {
                infoCustomer += data[key] ? (this.modeHTML ? `<p>${data[key]}</p>` : `${data[key]}\n`) :'';
            }
        }
        if(infoCustomer) infoCustomer += this.modeHTML ? `<p><br></p>` : '\n';
        // if mode==HTML remove start line in mailMessage: '<p><br></p><p><br></p><p><br></p>', '\n<br/>\n<br/>\n<br/>', '\n\n\n'
        let message = infoCustomer + bodyMsg;
        this.csv_header.map(header => message = message.replaceAll(`{${header}}`, data[header]));
        listMailTo.push(data[this.toHeader]);
        listPrefixMessage.push(infoCustomer);
      };
      let mailData = {
        body_type    : this.modeHTML ? 'HTML':'Text',
        to      : listMailTo,
        from    : this.mailFrom,
        subject : this.mailSubject,
        body    : bodyMsg,
        prefixBody: listPrefixMessage,
        cc      : listCC,
        bcc     : listBCC,
        files   : this.files,
        inquiry_type: this.inquiryType.value,
        type : this.type.value,
        mst_user_id : this.mst_user.value,
        send_type : 'bulk',
        delete_draft :  !this.viewMailDraft ? this.updateMailDraft : null,
      }
      if( this.$route.params.send_mail_id && mailNameSent ) mailData['id'] = parseInt(this.$route.params.send_mail_id)
      let success;
      if (this.receive_mail.id) {
        mailData.mail_id = this.receive_mail.id
        success = await this.replyMail(mailData)
        this.isSendInNewTab = true;
      } else {
        success = await this.createMail(mailData)
        this.isSendInNewTab = true;
      }
      if (!success){
        successAll = false;
      }

      if (successAll) {
        if (this.$route.query.mode == 'sdsk') {
          this.sendPostMessage('send', true);
          return;
        }
        this.onBack();
      } else {
        if (this.$route.query.mode == 'sdsk') {
          this.sendPostMessage('send', false);
          return;
        }
      }
    },
    sendPostMessage(type, result) {
      let data = {
        type,
        from: window.location.origin,
        result
      }
      let targetOrigin = getLS('from');
      window.postMessage(data, targetOrigin)
    },

    //Signature
    onGridReadySignature(params) {
      this.gridApiSignature = params.api;
      this.columnApiSignature = params.columnApi;
    },
    async onSelectionChangedSignature(){
      let selectedSignature = this.gridApiSignature.getSelectedRows()
      let listSignatureSelectId = [];
      selectedSignature.forEach(function (selectedRow, index) {
        listSignatureSelectId.push(selectedRow.id);
      });
      let signatureSelect = null
      this.listUserSignature.map((element)=>{
          if (listSignatureSelectId[0] == element.id){
            signatureSelect = element.signature;
          }
      })
      this.signatureSelect = signatureSelect
    },
    async applySignature() {
      if (this.modeHTML){
        const editor = this.tinymceEditor;
        if (!editor) return;
        //Get selection pointer cursor
        const selection = editor.selection;
        const bookmark = selection.getBookmark(2);
        //Insert
        let signatureSelect = this.convertHtmlToText(this.signatureSelect);
        signatureSelect = signatureSelect.replaceAll(/&lt;/g, '<')
        signatureSelect = signatureSelect.replaceAll(/&gt;/g, '>')
        signatureSelect = signatureSelect.replaceAll(/&amp;/g, '&')
        signatureSelect = signatureSelect.replaceAll(/\n/g, '<br>')
        editor.insertContent(signatureSelect);
        this.mailMessage = editor.getContent();
        this.popUpSignature = false
        setTimeout(() => {
          editor.focus();
          selection.moveToBookmark(bookmark);
          selection.collapse(false);
        }, 0);
      }
      else{
        var textMessage = document.getElementById('textMessage');
        let value = textMessage.value
        let start = textMessage.selectionStart
        let end   = textMessage.selectionEnd
        this.signatureSelect = this.signatureSelect.split('</p><p>')
        this.signatureSelect = this.signatureSelect.join("\n")
        this.signatureSelect = this.signatureSelect.split('&nbsp;')
        this.signatureSelect = this.signatureSelect.join(" ")
        const signatureSelect = DOMPurify.sanitize(this.signatureSelect,{USE_PROFILES: {html: false}});
        textMessage.value = value.slice(0, start) + signatureSelect + value.slice(end);
        textMessage.focus();
        textMessage.selectionEnd = start
        this.mailMessage = textMessage.value
        this.popUpSignature = false
      }
    },
    convertHtmlToText(html) {
      html = html.split('</p><p>')
      html = html.join("\n")
      html = html.split('&nbsp;')
      html = html.join(" ")
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    },
    convertTextToHtml(html) {
      html = html.split('<p><br>')
      html = html.join("\n")
      html = html.split('&nbsp;')
      html = html.join(" ")
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    },
    async autoSaveMailDraft(){
      if (this.autosave){
        clearTimeout(this.autosave)
      }
      this.autosave = setTimeout(() => {
        this.onSaveDraft();
      }, 5000)
    },
    async setPreMailDraft(){
      let preMailDraft = this.preMailDraft;
      preMailDraft.forEach(element=>{
        if (element.id == parseInt(this.$route.params.send_mail_id)){
          this.inquiryType = {
            label: element.inquiry_type_text, 
            value: element.inquiry_type
          };
          this.type = {
            label: element.kinds_name, 
            value: element.kinds_state
          };
          this.mst_user = {
            label: element.mst_user, 
            value: element.mst_user_id
          };
          this.listMailTo = (element.to && element.to.length > 0) ? element.to.split(",") : [];
          this.listMailCC = (element.cc && element.cc.length > 0) ? element.cc.split(",") : [];
          this.listMailBCC = (element.bcc && element.bcc.length > 0) ? element.bcc.split(",") : [];
          let listFileAttachment = (element.attachment_filepath && element.attachment_filepath.length > 0) ? element.attachment_filepath.split(",") : [];
          this.files = [];
          listFileAttachment.forEach((file)=>{
            this.files.push({file_name: file})
          });
          this.mailSubject = element.subject;
          this.modeHTML = element.body_type ? false : true;
          setTimeout(() => this.mailMessage = element.body, 0 );
          return;
        }
      })
    },
    async setModeHTML(mailSent){
      if (mailSent.body_type){
        this.modeHTML = mailSent.body_type == 0;
      } else{
        this.modeHTML = true;
      }
    },
    changeModeHTML(){
      if (this.modeHTML){
        if (this.mailMessage == '') this.modeHTML = false;
        else this.activeChangeModeHTML = true;
      } else{
        this.modeHTML = true;
        this.HTMLModeSplitLine = "<br/>";
      }
    },
    changeMessage(){
        const indexCharacter = 2;
      if(!this.modeHTML){
        if(this.$route.name == 'create-mail'){
          this.mailMessage = this.mailMessage.split('</p><p>')
          this.mailMessage = this.mailMessage.join("\n")
          this.mailMessage = this.mailMessage.split('&nbsp;')
          this.mailMessage = this.mailMessage.join(" ")
          this.mailMessage = DOMPurify.sanitize(this.mailMessage,{USE_PROFILES: {html: false}});
        }else{
          this.mailMessage = this.mailMessage.replace(/<!--\[if\s+mso\]>[\s\S]*?<!\[endif\]-->/gi, '')
              .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
          this.mailMessage = this.mailMessage.split('<br />').join("<br>\n")
          this.mailMessage = this.mailMessage.split('<p><span>').join("<p>").split('</span></p>').join("</p>")
          this.mailMessage = this.mailMessage.split('<p><br>').join("\n")
          this.mailMessage = this.mailMessage.split(' </p>').join("</p>")
          this.mailMessage = this.mailMessage.split('&nbsp;&nbsp;</p>').join("</p>")
          this.mailMessage = this.mailMessage.split('&nbsp;</p>').join("</p>")
          this.mailMessage = this.mailMessage.split(/<\/p>\s*<p[^>]*>/gi).join("</p><p>")
          this.mailMessage = this.mailMessage.split('&nbsp;\n').join("\n")
          this.mailMessage = htmlToFormattedText(this.mailMessage)
          let filltext = this.$route.name !== 'create-mail' ? "\n\n\n":"";
          this.mailMessage = filltext + Html5Entities.decode(this.mailMessage)
        }
        this.$nextTick(() => {
          let textMess  = document.getElementById('textMessage')
          textMess.selectionStart = this.$route.name !== 'create-mail' ? indexCharacter : 0;
          textMess.selectionEnd = this.$route.name !== 'create-mail' ? indexCharacter : 0;
          textMess.focus();
        });
      }else{
        this.mailMessage = this.mailMessage.replace('<', '&lt;').replace('>', '&gt;');
        this.mailMessage = this.mailMessage.replace('<', '&lt;').replace('>', '&gt;');
        this.mailMessage = this.mailMessage.replace('<', '&lt;').replace('>', '&gt;');
        this.mailMessage = this.mailMessage.replace('<', '&lt;').replace('>', '&gt;');
        this.mailMessage = this.convertTextToHtml(this.mailMessage);
        this.mailMessage = Html5Entities.encode(this.mailMessage)
        this.mailMessage = this.mailMessage.split('\n')
        this.mailMessage = this.mailMessage.join('\n<br/>')
        this.mailMessage = this.mailMessage.split(' ')
        this.mailMessage = this.mailMessage.join('&nbsp;')
        this.mailMessage = this.mailMessage + '<p><br></p>'
        this.$nextTick(() => {
            focusAtBrLine(this.tinymceEditor, this.$route.name);
        });
      }
    },
    async convertDateTime(dateTime){
      const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday","Saturday"];
      const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];
      let date = new Date(dateTime);
      let AmorPM = date.getHours() < 12 ? ' AM' : ' PM';
      let hour = date.getHours();
      if (hour > 12) hour -= 12;
      let time = hour + ':' + (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + AmorPM;
      let dateTimeFormatted = dayNames[date.getDay()] + ', ' + monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear() + ' ' + time;
      return dateTimeFormatted;
    },
    onEditorInit(editor) {
      this.tinymceEditor = editor;
      let contentEditor = editor.getContent();
      this.initialContentEditor = contentEditor;
      this.mailMessage = contentEditor;
      editor.off('KeyUp');
      if (this.isRead) {
        editor.setMode('readonly')
      }
      if (this.$route.name === 'view-mail-draft' && this.modeHTML) {
          const content = this.tinymceEditor.getContent();
          const doc = new DOMParser().parseFromString(content, 'text/html');
          let lines = doc.body.innerHTML.split(/<br\s*\/?>|<p>&nbsp;<\/p>/gi).map(line =>
              line.replace(/<[^>]*>/g, '').replace(/\s/g, '')
          );
          let row1 = lines[0] || '';
          let row2 = lines[1] || '';
          let row3 = lines[2] || '';

          if (row1.length > 0) {
              this.mailMessage = ' <br><br><br>' + this.mailMessage
          } else if (row1.length == 0 && row2.length > 0) {
              this.mailMessage = '<br><br>' + this.mailMessage
          } else if (row1.length == 0 && row2.length == 0 && row3.length > 0) {
              this.mailMessage = '<br>' + this.mailMessage
          }
      }

      this.$nextTick(() => {
          focusAtBrLine(this.tinymceEditor,this.$route.name);
          // Add a click event listener to the editor's document
          const doc = editor.getDoc();
          doc.addEventListener('click', (e) => {
              const target = e.target;
              if (target.tagName === 'A' && target.href) {
                  e.preventDefault();
                  window.open(target.href, '_blank');
              }
          });
      });
    },
    removeDuplicates(array) {
      return array.filter((item, index) => array.indexOf(item) === index);
    },
    extractMailToCCInfo(mail) {
      //Get mail info all: To, CC
      let matchMail = mail.match(/^(.*?) <.*$/);
      let nameMail = matchMail ? matchMail[1]: mail;
      const regexMail = /<([^<>]+?)>/.exec(mail);
      let emailLink = regexMail ? regexMail[1]: mail;
      return { nameMail, emailLink };
    },
    extractMailToCCLink(mailListname, mailListLink) {
      //Get mail link in body: To, CC
      mailListname = mailListname.trim().replace(/,$/, '');
      let mailToCCLlinkTrim = mailListLink.trim().replace(/,$/, '');
      let sendMailLinkToCC = mailToCCLlinkTrim ? " <"+ mailToCCLlinkTrim +">" : '';
      if(this.modeHTML && sendMailLinkToCC) {
        sendMailLinkToCC = sendMailLinkToCC.replace('<', '&lt;').replace('>', '&gt;');
      }
      return { mailListname, sendMailLinkToCC };
    },
    regexMailToCCBcc(email){
      //Get the mail inside the <> sign
      const startIndex = email.indexOf('<');
      const endIndex = email.indexOf('>');
      if (startIndex !== -1 && endIndex !== -1) {
        email = email.substring(startIndex + 1, endIndex);
      }
      return email.trim();
    },
    async checkMailReceiveActivity() {
        let url = new URL(window.location.href);
        let inquiryId = this.$route.params.inquiry_id;
        let getViewMailReply = url.searchParams.get("view-thread-mail");

        if (getViewMailReply && inquiryId) {
            const data = {
                'email' : this.$route.params.email,
                'inquiry_id' : inquiryId
            }

            let result = await this.getMailReceive(data);

            if (!result) {
                this.$vs.notify({
                    position: 'bottom-right',
                    text: notifyEmptyReceive,
                    color: 'danger'
                });
                return false;
            }
        }
        return true;
    }
  },
  async created () {
    if(this.$route.meta.isShowIConContact) {
      this.showIconContacts = true
    }
    let url = new URL(window.location.href);
    let onSendForWard = url.searchParams.get("send-forward") || false;
    let viewMailReplythread = url.searchParams.get("view-thread-mail") || false;
    this.readOnly = await this.setUserReadOnly(this.$route.params.email) > 0;
    await this.fetchContactList()
    /* start loading with many requests */
    this.$store.dispatch('updateLoads', true)

    if (this.$route.query.mode == 'sdsk' && getLS('postMessage')) {
      await this.handleShachihataDeskLogin();
    }
    let mailSent
    let mailSentId = this.$route.params.send_mail_id ? this.$route.params.send_mail_id : false
    let dataMailReceive
    if (mailSentId === false) {
      this.isRead = false
      if (this.$route.name === 'reply-mail') {
        // get mail receive
        const data = {
          'email' : this.$route.params.email,
          'inquiry_id' : this.$route.params.inquiry_id
        }
        dataMailReceive = await this.getMailReceive(data);
        if (dataMailReceive) {

          await this.getListKindsSelect()
          await this.getListMstUserSelect()
          this.receive_mail = dataMailReceive.receive_mail;
          this.countReplyMail = dataMailReceive.countReplyMail + 1;
          this.mailSubject = (onSendForWard ? "Fw: ":"Re: ")  + this.receive_mail.subject;
          this.inquiryType = this.listInquiryTypeSelect.find(item => item.value == dataMailReceive.receive_mail.inquiry_type)
          this.type = this.listTypeSelect.find(item => item.value === dataMailReceive.receive_mail.type)
          if(this.type === undefined){
            this.type = this.listTypeSelect.find(item => item.value === 0);
          }
          if (this.$route.query.mode == 'shachihatadesk') {
            let activeUserInfo = this.$store.state.AppActiveUser;
            if(activeUserInfo){
              this.mst_user = {
                label: activeUserInfo.family_name +' '+ activeUserInfo.given_name,
                value: activeUserInfo.id,
              }
            }
          }else{
            this.mst_user = this.listMstUserSelect.find(item => item.value == dataMailReceive.receive_mail.mst_user_id);
          }
          this.mailFrom = this.$route.params.email;
          const dateTime = await this.convertDateTime(this.receive_mail.receive_datetime);
          if(onSendForWard){
              this.listMailTo = [];
              let attachmentFile = dataMailReceive.receive_mail.attachmentFileName;
              if(attachmentFile.length > 0){
                attachmentFile.forEach(async element => {
                  let dataFile = {
                    "id" : dataMailReceive.receive_mail.id,
                    "fileName" : element.path,
                  }
                  let resultFile = await this.downloadFile(dataFile);
                  let fileSize = resultFile.file_data.length;
                  let fileEncodeResult = {
                    "file_name": resultFile.file_name,
                    "mime": resultFile.file_type, 
                    "file_content": resultFile.file_data,
                    "size": fileSize
                  }
                  this.files.push(fileEncodeResult);
                });
              }
          }else{
            let listMailTo = [];
            listMailTo.push(this.receive_mail.email_sender_full);
            listMailTo = listMailTo.concat(this.receive_mail.to ? this.receive_mail.to.split(',') : []);
            listMailTo.forEach(to =>{
              const emailTo = this.regexMailToCCBcc(to);
              if (!this.listMailTo.includes(emailTo) && this.mailFrom != emailTo) {
                this.sendlistMailTo.push(to);
              }
              to = this.regexMailToCCBcc(to);
              if (!this.listMailTo.includes(to) && this.mailFrom != to.trim()) {
                this.listMailTo.push(to);
              }
            });
          }
          this.modeHTML = this.receive_mail.body_type?false:true;
          let email_sender_full = this.receive_mail.email_sender_full;
          if(this.modeHTML) {
            email_sender_full = email_sender_full.replace('<', '&lt;').replace('>', '&gt;');
          }
          let lineBreak = this.modeHTML?'<br>':'\n';
          let fromQuote = lineBreak + 'From: '+email_sender_full;
          let datetimeQuote = lineBreak + 'Sent: '+dateTime;
          let toQuote = lineBreak + 'To: ';
          let ccQuote = "";
          if (this.receive_mail.to){
            let receive_mail_to_link = '';
            let receive_mail_to_name = '';
            let MailToList = this.receive_mail.to.split(',')
            MailToList.forEach(itemTo =>{
              receive_mail_to_name += itemTo.split("<")[0].trim()+', ';
              const startIndexTo = itemTo.indexOf('<');
              const endIndexTo = itemTo.indexOf('>');
              if (startIndexTo !== -1 && endIndexTo !== -1) {
                itemTo = itemTo.substring(startIndexTo + 1, endIndexTo);
              }
              receive_mail_to_link += itemTo +', ';
            });
            let mailToLlinkTrim = receive_mail_to_link.trim().replace(/,$/, '');
            let receiveMailLinkTo = mailToLlinkTrim ? " <"+ mailToLlinkTrim +">" : '';
            if(this.modeHTML && receiveMailLinkTo) {
              receiveMailLinkTo = receiveMailLinkTo.replace('<', '&lt;').replace('>', '&gt;');
            }
            toQuote = lineBreak + 'To: ' + "'"+ receive_mail_to_name.trim().replace(/,$/, '') + "' " + receiveMailLinkTo;
          }
          if(this.receive_mail.cc){
            let receive_mail_cc_link = '';
            let receive_mail_cc_name = '';
            let listCC = this.receive_mail.cc.split(',')
            listCC.forEach(itemCC =>{
              receive_mail_cc_name += itemCC.split("<")[0].trim()+', ';
              const startIndexCC = itemCC.indexOf('<');
              const endIndexCC = itemCC.indexOf('>');
              if (startIndexCC !== -1 && endIndexCC !== -1) {
                itemCC = itemCC.substring(startIndexCC + 1, endIndexCC);
              }
              receive_mail_cc_link += itemCC +', ';
            });
            let mailCcLlinkTrim = receive_mail_cc_link.trim().replace(/,$/, '');
            let receiveMailLinkCC = mailCcLlinkTrim ? " <" + mailCcLlinkTrim + ">" : '';
            if(this.modeHTML && receiveMailLinkCC) {
              receiveMailLinkCC = receiveMailLinkCC.replace('<', '&lt;').replace('>', '&gt;');
            }
            if(receive_mail_cc_name || receiveMailLinkCC){
              ccQuote = lineBreak + "CC: " + "'" + receive_mail_cc_name.trim().replace(/,$/, '') + "' "+ receiveMailLinkCC;
            }
          }
          const subjectQuote = lineBreak + 'Subject: '+this.receive_mail.subject;
          let email_body = this.receive_mail.body;
          let originalEmailQuote = this.originalTemplate + fromQuote + datetimeQuote + toQuote + ccQuote + subjectQuote;
          let threeLineBreak = this.modeHTML?'<br><br><br>':'\n\n\n'
          let mailMessage = threeLineBreak + originalEmailQuote + lineBreak + lineBreak + email_body;
          if(!this.modeHTML) {
            this.mailMessage = mailMessage;
          }
          this.$nextTick(() => {
            if(this.modeHTML) {
              this.mailMessage = mailMessage;
            } else {
              var pos = 2
              this.setSelRange(document.getElementById('textMessage'), pos, pos)
            }
          })
          if(!onSendForWard){
            let listMailCC = this.listMailCC.concat(this.receive_mail.cc ? this.receive_mail.cc.split(',') : []);
            listMailCC.forEach(cc =>{
              const emailCC = this.regexMailToCCBcc(cc);
              if (!this.listMailCC.includes(emailCC) && this.mailFrom != emailCC) {
                this.sendlistMailCC.push(cc);
              }
              cc = this.regexMailToCCBcc(cc);
              if (!this.listMailCC.includes(cc) && this.mailFrom != cc.trim()) {
                this.listMailCC.push(cc);
              }
            });
          } else {
            this.listMailCC = [];
            this.sendlistMailCC = [];
            this.sendlistMailTo = [];
          }
          await this.getUserSignature();
        } else {
            this.$vs.notify({
                position: 'bottom-right',
                text: notifyEmptyReceive,
                color: 'danger'
            });
            localStorage.setItem('refreshPage', true);
        }
      }
      if(this.$route.name === 'create-mail'){
        this.isReport = true
        this.listMailTo = []
        const mailBox = await this.getListMailBoxSend()
        await this.getListKindsSelect()
        await this.getListMstUserSelect()
        mailBox.filter( item =>{
          this.listMailFrom.push(item.sent_user_name)
        })
        this.mailFrom = ''
        if (this.$route.params.email) {
          let emailFrom = this.$route.params.email
          this.mailFrom = this.listMailFrom.find(mail => mail === emailFrom)
        }
        this.mailSubject = ''
        this.mailMessage = ''
        if(this.modeHTML) {
          document.getElementById('tinymceMessage').focus()
        } else {
          document.getElementById('textMessage').focus()
        }
        this.files = []
        this.listInquiryTypeSelect = [
          {value: 0, label: 'メール'},
          {value: 1, label: '電話'},
          {value: 2, label: '営業'},
          {value: 9, label: 'その他'}
        ],
        this.countReplyMail = 1
        // PAC_21-136
        this.type = this.type && this.listTypeSelect[1];
        let idUser = this.$store.state.AppActiveUser.id;
        this.mst_user = this.listMstUserSelect.find(item => item.value == idUser)
        // END PAC_21-136
      }
      
    } else {
      const data = {
        'id': mailSentId,
      }
      mailSent = await this.getMailSent(data)
      if( mailSent.state_flg === 0 ) {
        const mailBox = await this.getListMailBoxSend()
        mailBox.filter( item =>{
          this.listMailFrom.push(item.sent_user_name)
        })
        this.isRead = false
        this.isReport = true
        if (localStorage.enablePrevios){
          localStorage.removeItem("enablePrevios");
          this.isSetPreviousMail = true
        }
      } else {
        this.isRead = true
        this.isReport = false
      }

      if (mailSent) {
        await this.getListKindsSelect()
        await this.getListMstUserSelect()
        this.mailFrom = mailSent.email_sender

        let listMailTo = this.listMailTo.concat(mailSent.to ? mailSent.to.split(',') : []);
        listMailTo.forEach(to =>{
          this.sendlistMailTo.push(to);
          to = this.regexMailToCCBcc(to);
          this.listMailTo.push(to);
        });

        let listMailCC = this.listMailCC.concat(mailSent.cc ? mailSent.cc.split(',') : []);
        listMailCC.forEach(cc =>{
          this.sendlistMailCC.push(cc);
          cc = this.regexMailToCCBcc(cc);
          this.listMailCC.push(cc);
        });

        let listMailBCC = this.listMailBCC.concat(mailSent.bcc ? mailSent.bcc.split(',') : []);
        listMailBCC.forEach(bcc =>{
          bcc = this.regexMailToCCBcc(bcc);
          this.listMailBCC.push(bcc);
        });

        await this.setModeHTML(mailSent)
        this.mailMessage = mailSent.body ? mailSent.body : ''
        this.mailSubject = mailSent.subject ? mailSent.subject : ''
        this.inquiryType = this.listInquiryTypeSelect.find(item => item.value === mailSent.inquiry_type)
        this.type = this.listTypeSelect.find(item => item.value === mailSent.type)
        if(this.type === undefined){
          this.type = this.listTypeSelect.find(item => item.value === 0);
        }
        this.mst_user = this.listMstUserSelect.find(item => item.value === mailSent.mst_user_id)
        this.sentDateTime = mailSent.sent_datetime ? mailSent.sent_datetime : null;
      }
      if (this.$route.name === 'view-mail-sent') {
        this.viewMailSent = true
        this.countReplyMail = 1
        let attachmentFiles = mailSent.attachment_filepath
        if (attachmentFiles) {
          let listattachmentFiles = attachmentFiles.split(',')
          listattachmentFiles.forEach((element)=>{
            this.files.push({file_name: element})
          });
        }
      }
      if (this.$route.name === 'view-mail-draft'){
        if( onSendForWard ){
          this.listMailTo = [];
          this.listMailCC = [];
          this.sendlistMailTo = [];
          this.sendlistMailCC = [];
          this.mailSubject = 'Fw: ' + (mailSent.subject ? mailSent.subject.replace("Fw:",''):'');
        }
        const dateTime = await this.convertDateTime(mailSent.create_at);
        this.modeHTML = mailSent.body_type ? false : true;
        let email_sender_full = mailSent.email_sender + ' <' + mailSent.email_sender + '>';
        if(this.modeHTML) {
          email_sender_full = email_sender_full.replace('<', '&lt;').replace('>', '&gt;');
        }
        let lineBreak = this.splitLine;
        let fromQuote = lineBreak + "From: " + email_sender_full;
        let datetimeQuote = lineBreak + "Sent: " + dateTime;
        let toQuote = lineBreak + "To: ''";
        let ccQuote = lineBreak + "CC: ''";
        if (mailSent.to) {
          let send_mail_to_link = '';
          let send_mail_to_name = '';
          let MailToList = mailSent.to.split(',')
          MailToList.forEach(itemTo =>{
            const { nameMail, emailLink } = this.extractMailToCCInfo(itemTo);
            send_mail_to_name += nameMail+', ';
            send_mail_to_link += emailLink+', ';
          });
          const {
            mailListname, sendMailLinkToCC
          } = this.extractMailToCCLink(send_mail_to_name, send_mail_to_link);

          toQuote = lineBreak + 'To: ' + "'"+ mailListname + "' " + sendMailLinkToCC;

        }
        if (mailSent.cc) {
          let send_mail_cc_link = '';
          let send_mail_cc_name = '';
          let MailCCList = mailSent.cc.split(',')
          MailCCList.forEach(itemCC =>{
            const { nameMail, emailLink } = this.extractMailToCCInfo(itemCC);
            send_mail_cc_name += nameMail+', ';
            send_mail_cc_link += emailLink+', ';
          });
          const {
            mailListname, sendMailLinkToCC
          } = this.extractMailToCCLink(send_mail_cc_name, send_mail_cc_link);

          ccQuote = lineBreak + 'CC: ' + "'"+ mailListname + "' " + sendMailLinkToCC;
        } else {
          ccQuote = '';
        }
        let subject = mailSent.subject ? mailSent.subject : ""
        const subjectQuote = lineBreak + "Subject: " + subject;
        let email_body = mailSent.body;
        let originalEmailQuote =
          this.originalTemplate +
          fromQuote +
          datetimeQuote +
          toQuote +
          ccQuote +
          subjectQuote;
          let listMailCC = this.listMailCC.concat(this.receive_mail.cc ? this.receive_mail.cc.split(',') : []);
          listMailCC.forEach(cc =>{
            if (!this.listMailCC.includes(cc) && this.mailFrom != cc) {
              this.listMailCC.push(cc);
            }
          });
        if (email_body) {
          if(localStorage.getItem('statusSaveEmailBody')){
            this.mailMessage = (viewMailReplythread ? originalEmailQuote + lineBreak + lineBreak + (this.modeHTML ? '<p><br/><p>':''): '') + email_body;
            localStorage.removeItem('statusSaveEmailBody')
          }else{
            this.mailMessage =  email_body;
          }
        }
        else {
          this.mailMessage = originalEmailQuote + lineBreak + lineBreak;
        }
        this.$nextTick(() => {
          if(this.mailMessage !== '') {
            if(!this.modeHTML) {
              let lines = document.getElementById('textMessage').value.split('\n')
              let row1 = lines[0] ? lines[0].replaceAll(/\s/g,'') : ''
              let row2 = lines[1] ? lines[1].replaceAll(/\s/g,'') : ''
              let row3 = lines[2] ? lines[2].replaceAll(/\s/g,'') : ''
              if(row1.length > 0) {
                  this.mailMessage = '\n\n\n' + this.mailMessage
              } else if (row1.length == 0 && row2.length > 0) {
                  this.mailMessage = '\n\n' + this.mailMessage
              } else if (row1.length == 0 && row2.length == 0 && row3.length > 0) {
                  this.mailMessage = '\n' + this.mailMessage
              }
            }
          }
          if(!this.modeHTML) {
            setTimeout(() => {
              var pos = 2
              this.setSelRange(document.getElementById('textMessage'), pos, pos)
            }, 20)
          }
        })
        this.viewMailDraft = true
        this.countReplyMail = 1
        let attachmentFiles = mailSent.attachment_filepath
        if (attachmentFiles) {
          let listattachmentFiles = attachmentFiles.split(',')
          listattachmentFiles.forEach((element)=>{
            this.files.push({file_name: element})
          });
        }
      }
      if (this.$route.name === 'view-mail-reply') {
        this.countReplyMail = this.mailThreadView.index
        if(this.mailThreadView.attachment_filepath){
          this.mailThreadView.attachment_filepath.split(',').forEach(file_name => this.files.push({file_name: file_name}))
        }
      }
    }
    this.isCreated = true;
    //Get list mail template
    await this.getListMailTemplate({
      user_id: this.$store.state.AppActiveUser.id,
    });

    //Get list settings
    await this.getListSettingsSelect();

    /* stop loads */
      this.$store.dispatch('updateLoads', false)
      let mailDetail = await this.mailDetail;
      if (mailDetail) {
          // this.type = mailDetail.type
          // this.mst_user = mailDetail.mst_user
          this.state_flg = mailDetail.state_flg
          this.to = mailDetail.from
      }

      localStorage.setItem('mailDetail', JSON.stringify(mailDetail))
      if(!mailDetail && !localStorage.getItem('mailDetail')){
          this.$store.commit('receiveMail/CLEAR_MAIL_DETAIL')
      }
      if (!mailDetail && localStorage.getItem('mailDetail')) {
          const savedMailDetail = JSON.parse(localStorage.getItem('mailDetail'))
          this.$store.commit('receiveMail/SET_MAIL_DETAIL', savedMailDetail)
          localStorage.removeItem('mailDetail') //
      }

  },
  beforeDestroy(){
    // hiden popup while edit/update => click back/next on broswer (use activePopup = false not working)
    document.getElementById('dialogSend').style.display = 'none'
    if(this.isReport) window.removeEventListener('popstate', this.onBack);
  },
  beforeUpdate() {
    
  }
};
</script>


<style lang="scss">
@import "@/assets/scss/vuexy/components/view/sendMail.scss";
#page-send-mail{
  .vs__dropdown-toggle {
    .vs__selected-options {
      .vs__search {
        position: absolute;
        z-index: -1;
      }
    }
  }

  .vs-switch-primary {
    height: 40px!important;
    .vs-switch--text{
      font-size: 1rem;
    }    

    .vs-switch--circle{
      height: 24px!important;
      width: 24px!important;
      border-radius: 12px!important;
      top: 7px!important;
      left: 2px!important;
    }
  }

  .vs-switch-active .vs-switch--circle{
      margin-left: calc(100% - 29px)!important;
  }
  .text-Message {
    border: none !important;
    border-top: 1px solid rgba(0, 0, 0, 0.2) !important;
    border-radius: 0px;
    margin-top: 41px;
    textarea{
      font-size: 13px !important;
      padding: 15px;
      padding-top: 12px;
      font-family: Helvetica, Arial, sans-serif !important;
      line-height: 1.42 !important;
    }
  }
}
.border-box-all{
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}
.mail-template-list-dropdown {
  .vs-dropdown--menu {
    right: -250px;
    width: 300px;
    padding: 0 !important;

    .vs-divider {
      margin: 10px 0 0 0;
    }

    h5 {
      margin: 10px 0 0 5px;
    }
    .mail-template-list {
      height: 150px;
      overflow: scroll;

      .template-item {
        width: 100%;
        padding: 10px 10px;
        display: flex;
        justify-content: center;
        align-items: center;

        .vs-dropdown--item-link {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0;
        }

        .vs-icon{
          &:hover {
            cursor: pointer;
          }
        }

        &:hover {
          background-color: rgb(187, 187, 187);
        }

        &:nth-child(even):not(h5) {
          background-color: lightgrey;

          &:hover {
            background-color: rgb(187, 187, 187);
          }
        }
      }
    }
  }

  .vs-dropdown--menu--after {
      background-color: transparent !important;
  }
}

.vs-popup{
  .vs-popup--content{
    .vs-input-primary{
      width: 100%;
    }  
  }
}

.csv-content{
  max-height: 250px;
  overflow: auto;
}
.div-show-receive-mail{
  position: relative;
  .vs--single.vs--loading .vs__selected, .vs--single.vs--open .vs__selected {
    position: relative !important;
  }
  .v-select {
    border-radius: 6px;
    width: 120px;
    color : #ffffff;
    .vs__dropdown-toggle{
      border-radius: 6px !important;
      height: 40px;
      background-color: darkgray;
      color : #ffffff;
      .vs__selected{
        color : #ffffff;
       margin-top: 0 !important;
      }
    }
    #vs1__listbox li {
      padding: 10px ;
    }
  }
  #tinymceMessage {
    position: absolute;
    width: 100% !important;
    .tox-tinymce {
      min-height: 560px;
      height: 100%;
      .tox-statusbar {
        border: none !important;
        .tox-statusbar__text-container {
          display: none !important;
        }
      }
      .tox-editor-container {
        background: #fff !important;
        .tox-toolbar {
          background: none !important;
        }
        .tox-sidebar-wrap {
          border-top: 1px solid #cccc;
        }
        .tox-editor-header {
          width: 90% !important;
        }
      }
      .tox-tbtn--disabled {
        pointer-events: none !important;
      }
    }
  }

  }

.contact-li {
  font-size: 15px;
  padding: 3px 10px;
  &:hover {
    background-color: #5897fb;
  }
}
#contacts_dropdown {
  /* width */
  &::-webkit-scrollbar {
    width: 7px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

.vschipsContacts .con-chips .con-chips--remove-all {
  display: none;
}
</style>